import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { filterSingleDate_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingleDate_template";
import { filterAutocomplete_template } from "./filterAutocomplete_template";
import { DragAndDropHandler } from "../../utils/DragAndDropHandler";
import { infoButton_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import { Locale } from "../../utils/types/locale";
import { AffiliateLink } from "../../utils/types/affiliate_link";
import { TAG_DATA_FIELDS } from "../../utils/consts/tag_data_fields";
import { imageWidget_template } from "./imageWidget_template";
import {
  countryCodeFilter,
  streamRentBuyFilter,
} from "../../utils/AffiliateLinkHelper";
import { vignettePreview_template } from "./vignettePreview_template";
import TagDefaultsHelper from "../../utils/TagDefaultsHelper";
import { ID_TAG_TYPE } from "../../utils/consts/tag_type";
import {
  HYPERLINK_TYPE,
  Tag,
  TagHyperlink,
  VIGNETTE_ENABLED,
} from "../../utils/types/tag";
import { HYPERLINK_DATA_FIELDS } from "../../utils/consts/hyperlink_data_fields";
import * as tagPickerPresets from "../../utils/consts/tag_picker_presets";


declare var ko: any;
declare var CKEDITOR: any;

let tagDescriptionOverrideEditor;

const TAG_DISPLAY_CARD_TITLE = "Tag Display Card";
const TAG_HYPERLINK_TITLE = "Tag Hyperlink";
const TO_TAG_HYPERLINK_BUTTON_LABEL = "Change to Hyperlink Style";
const TO_TAG_DISPLAY_CARD_BUTTON_LABEL = "Change to Display Card Style";
const TO_TAG_HYPERLINK_BUTTON_ICON = "i-link";
const TO_TAG_DISPLAY_CARD_BUTTON_ICON = "i-vignette";
const INSERT_TAG_HYPERLINK_BUTTON_ICON = "i-insert-link";
const INSERT_TAG_DISPLAY_CARD_BUTTON_ICON = "i-ins";

export class tagPickerView_template extends vnTemplate {
  public filterAffiliates: filterAutocomplete_template;
  public linkExpirationDatePicker: filterSingleDate_template;
  protected automaticPricingTooltip: infoButton_template;
  protected automaticPricingTooltipContent;
  protected parent: any;
  public imageWidgetForTagOverrideEdit: imageWidget_template;
  public imageWidgetForTagIconOverrideEdit: imageWidget_template;
  public vignettePreview: vignettePreview_template;
  public defaultVignettePreview: vignettePreview_template;

  protected getTemplateHtml(): string {
    return /* html */ `
            <div class="w-picker-form form-view" id="tag-picker-view" data-bind="css: { 'is-visible': isShown }, template: { afterRender: onLoadTemplate }">

                <div class="picker-form">

                    <div class="form-header w-justify">
                        <div class="w-left">
                        </div>
                        <div class="w-center">
                            <div class="section-title">
                                <h3 class="section-title" data-bind="text: formTitle"></h3>
                            </div>
                        </div>
                        <div class="w-right">
                            <button type="button" class="close-btn icon i-close" data-bind="event: { click: onClickCancel }"></button>
                        </div>
                    </div>

                    <!-- Preset Select Step -->
                    <div data-bind="visible: presetSelectStep()" class="form-body w-quick-tag-pick">
                        <div class="quick-tag-pick group-4">
                          <button class="btn-temp-new temp-regular" type="button" data-bind="event: { click: onClickPresetLarge }">
                            <span class="w-icon"><span class="icon i-tag"></span></span>
                            <div class="temp-info"><span>Large</span><p>Quick inject specs, ratings, and links along a large image</p></div>

                          </button>
                          <button class="btn-temp-new temp-regular" type="button" data-bind="event: { click: onClickPresetMedium }">
                            <span class="w-icon"><span class="icon i-tag"></span></span>
                            <div class="temp-info"><span>Medium</span><p>Quick inject specs and ratings along with a medium image</p></div>
                          </button>
                          <button class="btn-temp-new temp-regular" type="button" data-bind="event: { click: onClickPresetSmall }">
                            <span class="w-icon"><span class="icon i-tag"></span></span>
                            <div class="temp-info"><span>Small</span><p>Quick inject a couple of specs along a small image</p></div>
                          </button>
                        </div>
                        <div class="quick-tag-pick group-2">
                          <button class="btn-temp-new temp-regular" type="button" data-bind="event: { click: onClickPresetReview }">
                            <span class="w-icon"><span class="icon i-star-full"></span></span>
                            <div class="temp-info"><span>Review</span><p>Load custom form with Large data options pre-selected</p></div>
                          </button>
                          <button class="btn-temp-new temp-regular" type="button" data-bind="event: { click: onClickPresetCustom }">
                            <span class="w-icon"><span class="icon i-multi"></span></span>
                            <div class="temp-info"><span>Custom</span><p>Load a custom form with no data options pre-selected</p></div>
                          </button>
                      </div>
                    </div>
                    <!-- End of Preset Select Step -->

                    <div data-bind="visible: !presetSelectStep()" class="form-body" >
                        <div class="body-header w-justify">
                            <div class="w-left">
                                <button type="button" class="btn icon i-edit" data-bind="visible: permissions()['tag_edit'].write, event: { click: onClickEditTagSource }">Edit tag source</button>
                                <button type="button" class="btn icon" data-bind="text: hyperlinkButtonLabel, visible: !isPartOfGroup() && isHyperLinkModeEnabled(), event: { click : onClickToggleHyperlink }, class: hyperlinkButtonIcon"></button>
                            </div>
                            <div class="w-right" style="gap:16px;">
                                <button type="button" class="btn icon i-ins" data-bind="visible: !isPartOfGroup() && !isSingle() && !isHyperlink(), event: { click : onClickAddToGroup }">Add To Group</button>
                                <button type="button" class="btn icon" data-bind="visible: !isPartOfGroup() && !groupExists(), event: { click : onClickInsert }, class: insertButtonIcon">Insert</button>
                                <button type="button" class="btn icon i-check" data-bind="visible: isPartOfGroup() && !isHyperlink(), event: { click : onClickSave }">Apply to Group</button>
                            </div>
                        </div>

                        <div class="tag-header">
                            <div class="tag-header-left">
                                <div class="form-group custom-badge" data-bind="visible: (vignette() != null || tagDefaults().vignette !== null )&& !isHyperlink()">
                                    <label for="" class="form-label icon i-vignette" style="margin-bottom:0px;">Display Type</label>
                                    <div class="form-check-inline width-auto">
                                        <input type="radio" id="display-type-image" name="radio-group-display-type" value="image" data-bind="checked: displayType">
                                        <label for="display-type-image">Image</label>
                                    </div>
                                    <div class="form-check-inline width-auto">
                                        <input type="radio" id="display-type-vignette" name="radio-group-display-type" value="vignette" data-bind="checked: displayType">
                                        <label for="display-type-vignette">Vignette</label>
                                    </div>
                                </div>
                                <div class="form-group" data-bind="visible: !isHyperlink()">
                                    <div class="w-img" data-bind="visible: image() != null && displayType() == 'image'">
                                        <button class="btn only-icon icon i-overwrite" type="button" title="overwrite image" data-bind="css: { 'is-overwrite' : imageOverride() != null }, event: { click: onClickImageOverride }"><span class="hidden-text">overwrite</span></button>
                                        <img data-bind="attr: {src: (image() != null ? image().url : '') }, css: { 'is-override' : imageOverride() != null }">
                                        <div class="w-img" data-bind="visible: imageOverride() != null ">
                                            <button class="btn icon i-overwrite" type="button" title="override image" data-bind="event: { click: onClickEditImageOverride }"><span>override</span></button>
                                            <button class="btn only-icon icon i-cross" type="button" title="cancel override" data-bind="event: { click: onClickDeleteImageOverride }"><span class="hidden-text">cancel override</span></button>
                                            <img data-bind="attr: { src :  (imageOverride() != null ? imageOverride().url : '') } ">
                                        </div>
                                    </div>


                                    <div class="icon-tag-type " data-bind="visible: (image() == null && displayType() == 'image'), class: type() != null ? type().name.replace(' ','-').toLowerCase() : ''">
                                        <button class="btn icon i-overwrite" type="button" title="override image" data-bind="event: { click: onClickImageOverride }"><span>override</span></button>
                                       <div class="w-img icon-img" data-bind="visible: imageOverride() != null && displayType() == 'image' ">
                                            <button class="btn icon i-overwrite" type="button" title="override image" data-bind="event: { click: onClickEditImageOverride }"><span>override</span></button>
                                            <button class="btn only-icon icon i-cross" type="button" title="cancel override" data-bind="event: { click: onClickDeleteImageOverride }"><span class="hidden-text">cancel override</span></button>
                                            <img data-bind="attr: { src :  (imageOverride() != null ? imageOverride().url : '') } " style="width: 10rem;">
                                        </div>
                                    </div>

                                </div>
                                <div class="form-group">
                                    <div class="form-group custom-badge" style="margin-left: 0" data-bind="visible: isHyperlink()">
                                        <label for="" class="form-label icon i-image" style="margin-bottom:0px;">Hyperlink Icon</label>
                                        <div class="form-check-inline width-auto">
                                            <input type="radio" id="yes-hyperlink-icon" name="radio-hyperlink-icon" value="true" data-bind="checked: showHyperlinkIcon">
                                            <label for="yes-hyperlink-icon">Yes</label>
                                        </div>
                                        <div class="form-check-inline width-auto">
                                            <input type="radio" id="no-hyperlink-icon" name="radio-hyperlink-icon" value="false" data-bind="checked: showHyperlinkIcon">
                                            <label for="no-hyperlink-icon">No</label>
                                        </div>
                                    </div>
                                    <div class="w-img icon-img" data-bind="visible: (!isHyperlink() && iconImage() != null && displayType() == 'image') || (isHyperlink() && showHyperlinkIcon() == 'true')">
                                        <button class="btn only-icon icon i-overwrite" type="button" title="overwrite icon" data-bind="visible: isHyperlink(), css: { 'is-overwrite' : isIconOverride() }, event: { click: onClickIconOverride }"><span class="hidden-text">overwrite</span></button>
                                        <button class="btn only-icon icon i-cross" type="button" title="cancel override" data-bind="visible: isHyperlink() && isIconOverride(), event: { click: onClickDeleteIconOverride }"><span class="hidden-text">cancel override</span></button>
                                        <!-- ko if: (isIconOverride() && iconOverride() == null) || (!isIconOverride() && iconImage() == null) -->
                                            <img style="width: 10rem; height: 10rem;">
                                        <!-- /ko -->
                                        <!-- ko if: isHyperlink() && isIconOverride() -->
                                            <img data-bind="attr: {src: (iconOverride() != null ? iconOverride().url : '') }">
                                        <!-- /ko -->
                                        <!-- ko if: !(isHyperlink() && isIconOverride()) -->
                                            <img data-bind="attr: {src: (iconImage() != null ? iconImage().url : '') }">
                                        <!-- /ko -->
                                        <!-- ko if: isHyperlink() && bannerImage() -->
                                            <img data-bind="attr: {src: (bannerImage() != null ? bannerImage().url : '') }">
                                        <!-- /ko -->
                                    </div>
                                </div>

                                <div class="tag-header-right">
                                    <div class="tag-header-bottom-row" style="flex-direction: column;" data-bind="css: { 'is-overwrite' : isTagColorOverride }">
                                        <!-- ko if: tagColor() && !isBrandOwner()-->
                                            <div class="form-group">
                                                <label for="" class="form-label icon i-color">Tag Color</label>
                                                <span class="form-read larger" data-bind="text: tagColor"></span>
                                                <div data-bind="{visible: tagColor(), style: { 'background-color': tagColor() }}" style="height: calc(1.25rem - 2px);
                                                    width: calc(1.25rem - 2px);
                                                    border: 1px solid #d1d1d1;
                                                    border-radius: 10%;
                                                    display: inline-block;
                                                    position: absolute;
                                                    right: 0;
                                                    top: 20px;"></div>
                                            </div>
                                        <!-- /ko -->
                                        <!-- ko if: (!tagColor() && tagDefaults().tagColor) || isBrandOwner() -->
                                            <div class="form-group default-value">
                                                <label for="" class="form-label icon i-color">Tag Color</label>
                                                <span class="form-read larger" data-bind="text: tagDefaults().tagColor"></span>
                                                <div data-bind="{visible: tagDefaults().tagColor, style: { 'background-color': tagDefaults().tagColor }}"
                                                    style="height: calc(1.25rem - 2px);
                                                        width: calc(1.25rem - 2px);
                                                        border: 1px solid #d1d1d1;
                                                        border-radius: 10%;
                                                        display: inline-block;
                                                        position: absolute;
                                                        right: 0;
                                                        top: 20px;
                                                    "
                                                ></div>
                                            </div>
                                        <!-- /ko -->

                                        <!-- ko if: isHyperlink() -->
                                            <!-- ko if: !tagColor() && !tagDefaults().tagColor && !isBrandOwner()-->
                                                <div class="form-group">
                                                    <label for="" class="form-label icon i-color">Tag Color</label>
                                                    <span class="form-read larger">No Color</span>
                                                </div>
                                            <!-- /ko -->

                                            <div class="form-group from-cke">
                                                <input type="checkbox" data-bind="checked: isTagColorOverride" id="isTagColorOverride">
                                                <label for="isTagColorOverride" class="icon i-check">Override Color CSS Code</label>
                                                <div>
                                                    <input class="input-text subtitle" data-bind="value: tagColorOverride" type="text" />
                                                    <div style="display: flex;
                                                    align-items: center;
                                                    gap: 1rem;
                                                    margin-top: 1rem;">
                                                        <label style="margin: 0;" class="form-label">Preview Color</label>
                                                        <div style="
                                                            height: 1.5rem;
                                                            width: 1.5rem;
                                                            border: 1px solid #d1d1d1;
                                                            border-radius: 10%;
                                                            display: inline-flex;
                                                            padding: 0.4rem;
                                                            align-items: center;
                                                            justify-content: center;
                                                        ">
                                                            <div data-bind="{style: { 'background-color': tagColorOverride() }}" style="height:100%; width:100%;
                                                                border: 1px solid #d1d1d1;
                                                                border-radius: 10%;
                                                                display: block;"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        <!-- /ko -->
                                    </div>
                                    <!-- ko if: !isHyperlink() -->
                                        <div class="form-group custom-badge" data-bind="visible: displayType() == 'image'">
                                            <label for="" class="form-label icon i-image" style="margin-bottom:0px;">Image Size</label>
                                            <div class="form-check-inline width-auto">
                                                <input type="radio" id="small" name="radio-group" value="small" data-bind="checked: viewType">
                                                <label for="small">Small</label>
                                            </div>
                                            <div class="form-check-inline width-auto">
                                                <input type="radio" id="medium" name="radio-group" value="medium" data-bind="checked: viewType">
                                                <label for="medium">Medium</label>
                                            </div>
                                            <div class="form-check-inline width-auto">
                                                <input type="radio" id="large" name="radio-group" value="large" data-bind="checked: viewType">
                                                <label for="large">Large</label>
                                            </div>
                                            <div class="form-check-inline width-auto">
                                                <input type="radio" id="hide" name="radio-group" value="hide" data-bind="checked: viewType">
                                                <label for="hide">Hide Image</label>
                                            </div>
                                        </div>

                                        <div class="form-group custom-badge" data-bind="visible: displayType() == 'image'">
                                            <label for="" class="form-label icon i-image" style="margin-bottom:0px;">Include Image Group</label>
                                            <div class="form-check-inline width-auto">
                                                <input type="radio" id="yes-image-group" name="radio-image-group" value="true" data-bind="checked: showImageGroup, disable: imageGroupDisabled">
                                                <label for="yes-image-group">Yes</label>
                                            </div>
                                            <div class="form-check-inline width-auto">
                                                <input type="radio" id="no-image-group" name="radio-image-group" value="false" data-bind="checked: showImageGroup">
                                                <label for="no-image-group">No</label>
                                            </div>
                                        </div>
                                        <!-- ko if: (imageGroup() != null) && (imageGroup().images.length > 0) -->
                                        <div class="w-img-group-count">
                                            <div class="form-group">
                                                <label for="" class="form-label icon i-gallery">Image Group</label>
                                                <span class="form-read larger"><span data-bind="text: imageGroup().images.length"></span> Image<!-- ko if: imageGroup().images.length !== 1 -->s<!-- /ko --> in Group</span>
                                            </div>
                                        </div>
                                        <!-- /ko -->

                                        <!-- ko if: enableTagVideo && tagVideo -->
                                        <div class="form-group custom-badge">
                                            <label for="" class="form-label icon i-video" style="margin-bottom:0px;">Include Video</label>
                                            <div class="form-check-inline width-auto">
                                                <input type="radio" id="yes-video-inclusion" name="radio-video-inclusion" value="true" data-bind="checked: includeVideo">
                                                <label for="yes-video-inclusion">Yes</label>
                                            </div>
                                            <div class="form-check-inline width-auto">
                                                <input type="radio" id="no-video-inclusion" name="radio-video-inclusion" value="false" data-bind="checked: includeVideo">
                                                <label for="no-video-inclusion">No</label>
                                            </div>
                                        </div>
                                        <!-- /ko -->

                                    <!-- /ko -->
                                </div>
                            </div>
                            <div class="tag-header-right">
                                <div class="tag-header-bottom-row" style="flex-direction: column;" data-bind="css: { 'is-overwrite' : titleOverride() != null }">

                                    <div class="form-group">
                                        <label for="" class="form-label icon i-tag" style="margin:1rem 0;">Tag Name</label>
                                        <span class="form-read larger" data-bind="text: name">Tom Hardy</span>
                                    </div>

                                    <div class="form-group from-cke">
                                        <input type="checkbox" data-bind="event: { click: onClickTitleOverride },checked: titleOverride() != null" id="titleOverride">
                                        <label for="titleOverride" class="icon i-check" data-bind="text: isHyperlink() ? 'Override Anchor Text' : 'Override Tag Name'"></label>
                                        <div><input class="input-text subtitle" data-bind="value: titleOverride" type="text" /></div>
                                    </div>
                                </div>

                                <div class="tag-header-bottom-row">

                                    <div class="form-group">
                                        <label for="" class="form-label icon i-tag-type" style="margin-bottom:1rem;">Tag Type</label>
                                        <span class="form-read larger" data-bind="text: idReferenceAndTagType"></span>
                                    </div>

                                </div>

                                <div class="tag-header-bottom-row" data-bind="visible: isHyperlink()">
                                    <div class="form-group custom-badge">
                                        <label for="" class="form-label icon i-vignette">Vignette</label>
                                        <div class="form-check-inline width-auto">
                                            <input type="radio" id="yes-hyperlink-vignette" name="radio-hyperlink-vignette" value="${
                                              VIGNETTE_ENABLED.YES
                                            }" data-bind="checked: hyperlinkVignette(), event: { click: onClickHyperlinkVignetteYes }">
                                            <label for="yes-hyperlink-vignette">Yes</label>
                                        </div>
                                        <div class="form-check-inline width-auto">
                                            <input type="radio" id="no-hyperlink-vignette" name="radio-hyperlink-vignette" value="${
                                              VIGNETTE_ENABLED.NO
                                            }" data-bind="checked: hyperlinkVignette(), event: { click: onClickHyperlinkVignetteNo }">
                                            <label for="no-hyperlink-vignette">No</label>
                                        </div>
                                    </div>
                                </div>

                                <div class="tag-header-bottom-row" data-bind="visible: isHyperlink()">
                                    <div class="form-group custom-badge">
                                        <label class="form-label icon i-link">Hyperlink URL</label>
                                        <div class="form-check-inline width-auto d-flex" style="flex:1; gap:0.5rem; align-items:center;">
                                            <input type="radio" id="internal-hyperlink-url" name="radio-hyperlink-url" value="${
                                              HYPERLINK_TYPE.INTERNAL
                                            }" data-bind="checked: hyperlinkInternalLink(), event: { click: onClickInternalHubPageLink }">
                                            <label for="internal-hyperlink-url">
                                                Internal Hub Page Link
                                            </label>
                                            <!-- ko if: brandOwner() && isBrandOwner() && !hyperlinkHasBrandOwnerLink() -->
                                                <span class="empty-label active" style="flex:1;">[CURRENTLY EMPTY]</span>
                                            <!-- /ko -->
                                            <!-- ko if: brandOwner() && !isBrandOwner() && !hyperlinkHasInternalLink() -->
                                                <span class="empty-label active" style="flex:1;">[CURRENTLY EMPTY]</span>
                                            <!-- /ko -->
                                        </div>
                                        <!-- ko if: brandOwner() && !isBrandOwner() -->
                                           <div class="form-check-inline width-auto d-flex" style="flex:1; gap:0.5rem; align-items:center;">
                                                <input type="radio" id="brand-owner-hyperlink-url" name="radio-hyperlink-url" value="${
                                                  HYPERLINK_TYPE.BRAND_OWNER
                                                }" data-bind="checked: hyperlinkInternalLink(), event: { click: onClickBrandOwnerHubPageLink }">
                                                <label for="brand-owner-hyperlink-url">
                                                    Link to <span data-bind="text: brandOwner().name"></span> Hub page
                                                </label>
                                                <!-- ko if: !hyperlinkHasBrandOwnerLink() -->
                                                <span class="empty-label active" style="flex:1;">[CURRENTLY EMPTY]</span>
                                                <!-- /ko -->
                                            </div>
                                        <!-- /ko -->
                                    </div>
                                </div>

                                <div class="form-group">
                                    <hr class="form-hr" style="margin-top:0;"/>
                                </div>

                                <div class="tag-header-bottom-row" data-bind="css: { 'is-overwrite' : descriptionOverride() != null }, visible: !isHyperlink()">

                                    <div class="form-group" data-bind="css: { 'default-value': useTagDefaults().description }">
                                        <label for="" class="form-label">Description</label>
                                        <span class="form-read"
                                            data-bind="
                                                html: (isBrandOwner() || useTagDefaults().description)?
                                                    (tagDefaults().description? tagDefaults().description : 'None') :
                                                    (description? description : 'None')
                                            "
                                        ></span>
                                    </div>

                                    <!--<button class="btn icon i-overwrite" type="button" data-bind="event: { click: onClickDescriptionOverride }"><span>override</span></button>-->
                                    <!--<button class="btn only-icon icon i-cross" type="button" title="cancel override" data-bind="event: { click: onClickDeleteDescriptionOverride }"><span class="hidden-text">cancel override</span></button>-->

                                    <div class="form-group from-cke" >
                                        <input type="checkbox" data-bind="event: { click: onClickDescriptionOverride }, checked: descriptionOverride() != null" id="description-override">
                                        <label for="description-override" class="icon i-check">Override</label>
                                        <div><textarea id="tag_description_override" data-bind="value: descriptionOverride"></textarea></div>
                                    </div>
                                </div>

                                <div class="tag-header-bottom-row" data-bind="css: { 'is-overwrite' : seoDescriptionOverride() != null }, visible: !isHyperlink()">

                                    <div class="form-group" data-bind="css: { 'default-value': useTagDefaults().shortDescription }">

                                        <label for="" class="form-label">Seo Description</label>
                                        <span class="form-read"
                                            data-bind="
                                                text: (isBrandOwner() || useTagDefaults().shortDescription)?
                                                    (tagDefaults().shortDescription? tagDefaults().shortDescription : 'None') :
                                                    (seoDescription()? seoDescription : 'None')
                                                "
                                            ></span>
                                    </div>

                                   <!-- <button class="btn icon i-overwrite" type="button" data-bind="event: { click: onClickSeoDescriptionOverride }"><span>override</span></button>-->
                                    <!--<button class="btn only-icon icon i-cross" type="button" title="cancel override" data-bind="event: { click: onClickDeleteSeoDescriptionOverride }" ><span class="hidden-text">override</span></button>-->

                                    <div class="form-group">
                                        <input type="checkbox" data-bind="event: { click: onClickSeoDescriptionOverride }, checked: seoDescriptionOverride() != null" id="seo-description-override">
                                        <label for="seo-description-override" class="icon i-check">Override</label>
                                        <div><textarea data-bind="value: seoDescriptionOverride"></textarea></div>
                                    </div>
                                </div>

                                <div class="tag-header-bottom-row" data-bind="css: { 'is-overwrite' : reviewScoreOverride() != null && !reviewScoreIsUnderEmbargo() }, visible: !isHyperlink()">
                                    <!-- *** BEGIN: REVIEW SCORE NOT UNDER EMBARGO *** -->
                                    <!-- ko if: !reviewScoreIsUnderEmbargo() -->
                                    <div class="form-group rating">
                                        <label for="" class="form-label">Review Score</label>
                                        <span class="form-read" data-bind="text: reviewScore() != null ? reviewScore() + ' / 10' : 'No Score Saved'"></span>
                                    </div>

                                    <!--<button class="btn icon i-overwrite" type="button" data-bind="event: { click: onClickReviewScoreOverride }"><span>override</span></button>-->
                                    <!--<button class="btn only-icon icon i-cross" type="button" title="cancel override" data-bind="event: { click: onClickDeleteReviewScoreOverride }" ><span class="hidden-text">override</span></button>-->

                                    <div class="form-group row rating">
                                        <input type="checkbox" data-bind="event: { click: onClickReviewScoreOverride }, checked: reviewScoreOverride() != null" id="review-score-override">
                                        <label for="review-score-override" class="icon i-check">Override</label>
                                        <div>
                                        <input class="input-text number" type="number" step="0.1" min="0.1" max="10" placeholder="X.X" data-bind="value: reviewScoreOverride" >
                                        <span>/ 10</span>
                                        </div>
                                    </div>
                                    <!-- /ko -->
                                    <!-- *** END: REVIEW SCORE NOT UNDER EMBARGO *** -->

                                    <!-- *** BEGIN: REVIEW SCORE UNDER EMBARGO -- CASE WITH EMBARGO PERMISSION *** -->
                                    <!-- Users can see the review score, no review score override  -->
                                    <!-- ko if: reviewScoreIsUnderEmbargo() &&  embargoPermissions().write -->
                                    <div class="form-group rating">
                                        <label for="" class="form-label">Review Score</label>
                                        <span class="form-read" data-bind="text: reviewScore() != null ? reviewScore() + ' / 10' : 'No Score Saved'"></span>

                                        <label for="" class="form-label" style="margin-top: 2rem">Review Embargo End Date</label>
                                        <span class="form-read" data-bind="text : reviewScoreEmbargoEndDate() != null ? 'Score Under Embargo Until ' + reviewScoreEmbargoEndDate() : '' "></span>

                                        <div class="form-group form-check-inline" style="margin: 2rem 2rem">
                                           <input type="checkbox" data-bind="checked: embargoScoreIsIncluded" id="embargo_score_include">
                                           <label for="embargo_score_include" class="form-label icon i-check" style="line-height: 1.3;">Include Embargo score</label>
                                        </div>
                                    </div>
                                    <!-- /ko -->
                                    <!-- *** END: REVIEW SCORE UNDER EMBARGO -- CASE WITH EMBARGO PERMISSION *** -->


                                    <!-- *** BEGIN: REVIEW SCORE UNDER EMBARGO -- CASE WITH NO EMBARGO PERMISSION *** -->
                                    <!-- Users cannot see the review score, no review score override  -->
                                    <!-- ko if: reviewScoreIsUnderEmbargo() &&  !embargoPermissions().write -->
                                    <div class="form-group rating">
                                        <label for="" class="form-label">Review Score</label>
                                        <span class="form-read" data-bind="text : (reviewScoreEmbargoEndDate() ? 'Score Under Embargo Until ' + reviewScoreEmbargoEndDate() : '' ) " ></span>

                                        <div class="form-group form-check-inline" style="margin: 2rem 2rem">
                                            <input type="checkbox" data-bind="checked: embargoScoreIsIncluded" id="embargo_score_include">
                                            <label for="embargo_score_include" class="form-label icon i-check" style="line-height: 1.3;">Include Embargo score</label>
                                        </div>
                                    </div>

                                    <!-- /ko -->
                                    <!-- *** END: REVIEW SCORE UNDER EMBARGO -- CASE WITH NO EMBARGO PERMISSION *** -->
                                </div>

                                <!-- ko if: type() && type().id != ID_TAG_TYPE.PERSON -->
                                <div class="tag-header-bottom-row">
                                    <div class="form-group community-rating">
                                        <label for="" class="form-label">Community Rating</label>
                                        <span class="form-read" data-bind="text: (communityRating().average ?? 0) + '/10 - ' + communityRating().count + ' votes'"></span>
                                    </div>
                                    <div class="form-group community-rating"
                                        data-bind="css: { 'is-disable': isPartOfGroup() }"
                                    >

                                        <input type="checkbox"
                                            data-bind="
                                                event: { click: onClickIncludeCommunityRating },
                                                checked: isPartOfGroup()? isGroupCommunityRatingShown() : includeCommunityRating()
                                            "
                                            id="include-community-rating"
                                        />
                                        <label for="include-community-rating"
                                            class="icon i-check"
                                        >
                                            Include Community Rating
                                        </label>

                                    </div>
                                </div>
                                <!-- /ko -->
                            </div>
                        </div>
                        <div class="tag-body" data-bind="visible: !isHyperlink()">
                            <strong class="sub-title">Links</strong>
                            <div class="tag-header-right-row affiliate-link">
                                    <div class="form-group" style="display: flex; align-items: center;border: 0;">
                                        <label class="form-label" style="margin: 0">Source Links</label>
                                    </div>
                                    <div class="form-group" style="display: flex; align-items: center;border: 0;">
                                        <label class="form-label" style="margin: 0">Links</label>
                                        <button class="btn only-icon icon i-plus " type="button" data-bind="event: { click: onClickShowAffiliateLink }"></button>
                                    </div>

                             </div>
                            <div class="tag-header-right-row affiliate-link">
                                    <div class="form-group affiliate-list">
                                        <!-- ko if: !useTagDefaults().affiliateLinks && !isBrandOwner() -->
                                            <!-- ko foreach: affiliateLinks -->
                                                ${this.getAffiliateLinksHtml()}
                                            <!-- /ko -->
                                            <div class="form-row" data-bind="visible: hasStreamRentBuyLinks">
                                                <div class="form-row">
                                                    <input type="checkbox" id="streamrentbuy-links" data-bind="checked: $data.includeStreamRentBuyLinks">
                                                    <label data-bind="text: buildAffiliateOptionsString(), attr: { for: 'streamrentbuy-links' }" class="form-label icon i-check"></label>
                                                </div>
                                            </div>
                                        <!-- /ko -->
                                        <!-- ko if: useTagDefaults().affiliateLinks || isBrandOwner() -->
                                            <!-- ko foreach: tagDefaults().affiliateLinks -->
                                                ${this.getAffiliateLinksHtml()}
                                            <!-- /ko -->
                                            <div class="form-row" data-bind="visible: hasDefaultStreamRentBuyLinks">
                                                <div class="form-row">
                                                    <input type="checkbox" id="streamrentbuy-links" data-bind="checked: $data.includeStreamRentBuyLinks">
                                                    <label data-bind="text: buildAffiliateOptionsString(), attr: { for: 'streamrentbuy-links' }" class="form-label icon i-check"></label>
                                                </div>
                                            </div>
                                        <!-- /ko -->
                                    </div>

                                    <div class="form-group affiliate-list" data-bind="foreach: tempAffiliateLinks, childrenComplete : handleDragAndDrop($element, tempAffiliateLinks ,'.form-row') ">
                                           <div class="form-row">
                                                <label data-bind="text: type, attr: { for: 'affiliateLinkView_' + id + '_' + $index() }" class="form-label icon i-drag"></label>
                                                <div>
                                                    <div class="affiliate-price">
                                                        <span class="form-read" data-bind="text: !$data.automaticPricing && $data.salePrice ? '$' + salePrice : ''"> </span>
                                                        <span class="form-read" data-bind="text: !$data.automaticPricing && $data.price ? '$' + price : '', css: { 'regular-price' : $data.salePrice }"> </span>
                                                        <span class="form-read" data-bind="text: !$data.automaticPricing && $data.price && $data.salePrice ? 'Save $' + (Math.round((price - salePrice) * 100) / 100) : ''"> </span>
                                                        <span class="form-read" style="position:relative;left:-1em;" data-bind="text: $data.automaticPricing ? 'Automatic Pricing' : ''"> </span>
                                                    </div>
                                                    <a target="_blank" data-bind="attr: { id : 'link-preview-' + $data.id  + '_' + $index(), href : value}, text : value.substr(0,30) + '...'" id="site-view202761"></a>
                                                </div>
                                                <div style="display: flex; justify-content: flex-end;">
                                                    <button class="btn only-icon icon i-edit" data-bind="event: { click: $parent.onClickEditLink }"><span class="hidden-text">edit</span></button>
                                                    <button class="btn only-icon icon i-cross" type="button" data-bind="event: { click: $parent.onClickDeleteLink }"><span class="hidden-text">delete</span></button>
                                                </div>
                                           </div>
                                    </div>
                                </div>
                         </div>
                        <div class="tag-body" data-bind="visible: !isHyperlink()">
                            <strong class="sub-title">Article Specifics</strong>
                            <div class="form-body flex badge">
                                <div class="form-group badge">
                                    <div class="form-row">
                                      <label for="template" class="form-label" style="margin:0 .5rem 0 0;flex:none;">Badge</label>
                                      <select id="idBadge" class="form-select"data-bind="options: badgeOptions, optionsText: 'name', value: badge, optionsValue: 'name', optionsCaption: 'Choose a badge', valueAllowUnset: true, event: {change: onChangeBadge}"></select>
                                      <input class="input-text" placeholder="Type Badge Name" data-bind="value: customBadge, visible: badge() == 'Custom Badge'" type="text">
                                    </div>
                                    <div class="form-row custom-badge" data-bind="visible: badge() == 'Custom Badge'">
                                      <label for="template" class="form-label" style="flex:none;">Image</label>
                                        <div class="w-custom-badge">
                                            <div>
                                               <button class="btn icon i-image only-icon" type="button" title="select image" data-bind="event: { click: onClickEditBadgeImage }"></button>
                                               <button class="btn icon i-delete only-icon" type="button" title="delete image" data-bind="visible: badgeImage() != null, event: { click: onClickDeleteBadgeImage }"></button>
                                            </div>
                                            <div><img data-bind="attr: {src: (badgeImage() != null ? badgeImage().url : '') }" width="" height=""></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group flex">
                                      <label for="template" class="form-label" style="margin:0 .5rem 0 0;">Subtitle</label>
                                      <input class="input-text subtitle" data-bind="value: subtitle" type="text">
                                </div>
                            </div>
                            <strong class="sub-title" style="background: #52545a">Pros & Cons</strong>
                            <div class="form-body flex" style="align-items: flex-start;">
                                <div class="form-group pros-cons">
                                    <div class="form-row">
                                        <label class="form-label">Pros</label>
                                        <button class="btn only-icon icon i-plus" type="button" data-bind="event: { click: onClickAddPro }"></button>
                                    </div>
                                    <!-- ko foreach: tagItemPro -->
                                        <div class="form-row icon i-thumb-up" style="margin-bottom:.5rem;">
                                            <input class="input-text" data-bind="value: data, valueUpdate: ['afterkeydown', 'input'] " type="text">
                                            <button class="btn only-icon icon i-cross" type="button" data-bind="event: { click: $parent.onClickDeletePro.bind($data, $index)}"><span class="hidden-text">delete</span></button>
                                        </div>
                                    <!-- /ko -->
                                </div>

                                <div class="form-group pros-cons">
                                    <div class="form-row">
                                        <label class="form-label">Cons</label>
                                        <button class="btn only-icon icon i-plus" type="button" data-bind="event: { click: onClickAddCon }"></button>
                                    </div>
                                    <!-- ko foreach: tagItemCon -->
                                        <div class="form-row icon i-thumb-down" style="margin-bottom:.5rem;">
                                            <input class="input-text" data-bind="value: data, valueUpdate: ['afterkeydown', 'input']" type="text">
                                            <button class="btn only-icon icon i-cross" type="button" data-bind="event: { click: $parent.onClickDeleteCon.bind($data, $index)}"><span class="hidden-text">delete</span></button>
                                        </div>
                                    <!-- /ko -->
                                </div>

                            </div>
                        </div>
                        <!-- is-is-group-selected if a group of tag is selected -->
                        <div class="tag-body" data-bind="css: { 'is-group-selected': isPartOfGroup }, visible: !isHyperlink()">

                            <strong class="sub-title">Specifications</strong>
                            <p class="form-text group-msg">* Spec selections cannot be changed for individual tags that have been added to a group.<br />You can modify the group’s specs selection using the specs menu in the right sidebar.</p>
                            <div class="form-group w-btn" data-bind="visible: specs().length > 0">
                                <button class="btn icon i-select" type="button" data-bind="event: { click : onClickSelectAllSpecs }">All Spec</button>
                                <button class="btn icon i-deselect" type="button" data-bind="event: { click : onClickDeSelectAllSpecs }">No Spec</button>
                            </div>

                            <div class="form-group spec" data-bind="foreach: specs , childrenComplete : handleDragAndDrop($element, specs ,'.form-row') ">
                                <!-- ko ifnot: dataType == 'images' -->
                                <div class="form-row">
                                    <div class="btn reorder only-icon icon i-move i-drag"><span class="hidden-text">move</span></div>
                                    <input type="checkbox" data-bind="checked: $data.selected, attr: { id: 'specField_' + fieldId }">
                                    <label class="form-label icon i-check" data-bind="text: (dataType == 'rating') ? (label + '  - /' + ratingScale) : label, attr: { for: 'specField_' + fieldId }"></label>
                                    <!-- ko if: isDefault -->
                                    <span class="form-read" data-bind="html: defaultValue"></span>
                                    <!-- /ko -->
                                    <!-- ko ifnot: isDefault -->
                                    <span class="form-read" data-bind="html: value"></span>
                                    <!-- /ko -->
                                </div>
                                <!-- /ko -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-lightbox light-theme" data-bind="css: { 'is-visible': isAffiliateLinksFormShown }">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form" style="width:40rem;">
                        <div class="form-header">
                            <h3 class="form-title">Add Link</h3>
                            <button type="button" class="close-button icon i-close-2" data-bind="event: {click: onClickCancelAffiliateLink }" ></button>
                        </div>

                        <div class="form-body">
                            <div class="form-group">
                               ${this.filterAffiliates.getHtmlBuild()}
                            </div>

                            <div class="form-group row form-check-inline" data-bind="visible: affiliateAutomaticPricingAvailable">
                                <input id="automatic-pricing-view" type="checkbox" data-bind="checked: affiliateAutomaticPricing">
                                <label for="automatic-pricing-view" class="icon i-check">automatic pricing</label>
                                <div class="w-tooltips-adv pos-top short" style="top: 0.5em;position: relative;">
                                    ${this.automaticPricingTooltip.getHtmlBuild()}
                                </div>
                            </div>
                            <div class="form-group row" data-bind="visible: !affiliateAutomaticPricingAvailable() || !affiliateAutomaticPricing()">

                                <label for="" class="form-label">sale price</label>
                                <div style="display: flex;align-items: center">
                                    <span class="form-label" style="margin-right: .5rem">$</span>
                                    <input class="input-text number"  data-bind="value: affiliateSalePrice" type="number">
                                </div>
                            </div>
                            <div class="form-group row" data-bind="visible: !affiliateAutomaticPricingAvailable() || !affiliateAutomaticPricing()">
                                <label for="" class="form-label">full price</label>
                                <div style="display: flex;align-items: center">
                                    <span class="form-label" style="margin-right: .5rem">$</span>
                                    <input class="input-text number"  data-bind="value: affiliatePrice" type="number">
                                </div>
                            </div>
                            <div class="form-group inside-label">
                                 <label for="" class="form-label">url</label>
                                 <input class="input-text"  data-bind="value: affiliateUrl" type="text">
                            </div>
                            <div class="form-group row">
                                 <label for="" class="form-label">expiration</label>
                                 <select name="" id="" data-bind="value: affiliateExpirationOption">
                                      <option value="1">None</option>
                                      <option value="2">Now</option>
                                      <option value="3">Scheduled</option>
                                 </select>
                            </div>
                            <div class="form-group" data-bind="visible: affiliateExpirationOption() == 3">
                                        <!--<label for="" class="form-label">expiration</label>-->
                                        ${this.linkExpirationDatePicker.getHtmlBuild()}
                            </div>
                            <div class="form-group inside-label">
                                 <label for="" class="form-label">link text override</label>
                                 <input class="input-text"  data-bind="value: affiliateLinkTextOverride" type="text">
                           </div>
                         </div>

                        <div class="form-footer">
                            <button type="button" class="btn" data-bind="event: {click: onClickCancelAffiliateLink }">Cancel</button>
                            <button type="button" class="btn highlight icon i-check" data-bind="event: {click: onClickAddAffiliateLink }">Save</button>
                        </div>
                    </div>
                </div>
            </div>
            `;
  }

  protected getAffiliateLinksHtml(): string {
    return /* html */ `
            <div class="form-row" data-bind="visible: !$data.countryCode ?? false">
                <input type="checkbox" data-bind="checked: $data.selected, attr: { id: 'affiliateLinkView_' + id + '_' + $index() }">
                <label data-bind="text: type, attr: { for: 'affiliateLinkView_' + id + '_' + $index()}" class="form-label icon i-check"></label>
                <div>
                    <div class="affiliate-price">
                        <span class="form-read" data-bind="text: !$data.automaticPricing && $data.salePrice ? '$' + salePrice : ''"> </span>
                        <span class="form-read" data-bind="text: !$data.automaticPricing && $data.price ? '$' + price : '', css: { 'regular-price' : $data.salePrice }"> </span>
                        <span class="form-read" data-bind="text: !$data.automaticPricing && $data.price && salePrice ? 'Save $' + (Math.round((price - salePrice) * 100) / 100) : ''"> </span>
                        <span class="form-read" style="position:relative;left:-1em;" data-bind="text: $data.automaticPricing ? 'Automatic Pricing' : ''"> </span>
                    </div>
                    <a target="_blank" data-bind="attr: { id : 'link-preview-' + $data.id, href : value}, text : value.substr(0,30) + '...'" id="site-view202761"></a>
                </div>
            </div>
        `;
  }

  public getViewModelForRequest() {
    return {};
  }

  public setLocales(locales: Locale[]): this {
    this.getTemplateViewModel().locales = locales;

    return this;
  }

  public set_enableTagVideo(enableTagVideo: boolean): this {
    this.getTemplateViewModel().enableTagVideo = enableTagVideo;
    return this;
  }

  public setupUseTagDefaults(tag: Tag | null = null): void {
    const vm = this.getTemplateViewModel();

    return TagDefaultsHelper.setupUseTagDefaults(
      vm,
      null,
      null,
      null,
      null,
      tag
    );
  }

  protected initPartial(): void {
    this.automaticPricingTooltipContent = `
        <p>
        When checked the most up-to-date pricing will be used if it is available.
        </p>
        `;
    this.automaticPricingTooltip = new infoButton_template(
      "automaticPricingTooltip",
      this.getTemplateViewModel(),
      this.caller
    );
    this.automaticPricingTooltip.setTitle("Automatic Pricing");
    this.automaticPricingTooltip.setContent(
      this.automaticPricingTooltipContent
    );

    this.filterAffiliates = new filterAutocomplete_template(
      "filterAutocompleteTagViewAffiliate_template",
      this.getTemplateViewModel(),
      this.caller
    );
    this.filterAffiliates.setAddNewOptionEnabled(true);
    this.filterAffiliates.setNumberOfChars(1);
    this.filterAffiliates.setPlaceholder("Affiliate Partner");
    this.filterAffiliates.setOptionType("Affiliate Partner");

    this.linkExpirationDatePicker = new filterSingleDate_template(
      "linkExpirationDatePicker",
      this.getTemplateViewModel(),
      this.caller
    );
    this.linkExpirationDatePicker.setDate(
      this.getFormattedEasternTimeZoneDateTime("/")
    );

    this.imageWidgetForTagOverrideEdit = new imageWidget_template(
      "tagImageEditOverride",
      this.getTemplateViewModel(),
      this
    );
    this.imageWidgetForTagOverrideEdit.setMode("single-select");

    this.imageWidgetForTagIconOverrideEdit = new imageWidget_template(
      "tagIconEditOverride",
      this.getTemplateViewModel(),
      this
    );
    this.imageWidgetForTagIconOverrideEdit.setMode("single-select");

    this.vignettePreview = new vignettePreview_template(
      "vignettePreview",
      this.getTemplateViewModel(),
      this.caller
    );
    this.vignettePreview.setIsFixedHeight(true);
    this.vignettePreview.setDefaultHeight("16rem");

    this.defaultVignettePreview = new vignettePreview_template(
      "defaultVignettePreview",
      this.getTemplateViewModel(),
      this.caller
    );
    this.defaultVignettePreview.setIsFixedHeight(true);
    this.defaultVignettePreview.setDefaultHeight("16rem");
  }

  public setAffiliateFilterOptions(affiliates) {
    this.filterAffiliates.setOptions(affiliates);
  }

  public clearAutomaticPricingOptions() {
    this.getTemplateViewModel().affiliateAutomaticPricingAvailable(false);
    this.getTemplateViewModel().affiliateAutomaticPricing(null);
  }

  protected getTemplateName(): string {
    return "tagPickerView-template";
  }

  protected getMainElementType(): string {
    return "div";
  }

  protected getMainElementClasses(): Array<string> {
    return [];
  }

  public set_isHyperLinkModeEnabled(enabled) {
    this.getTemplateViewModel().isHyperLinkModeEnabled(enabled);
  }

  protected buildViewModel(): any {
    //create observable array refresh function
    ko.observableArray.fn.refresh = function (item, index) {
      if (index == null) index = this["indexOf"](item);
      if (index >= 0) {
        this.splice(index, 1, ko.utils.extend({}, item)); // create new item
      }
    };

    // define the viewmodel data/ functions
    let huit_neuf_this = this;
    let viewModel = {
      isShown: ko.observable(false),
      isAffiliateLinksFormShown: ko.observable(false),
      formTitle: ko.pureComputed(() => {
        return viewModel.isHyperlink()
          ? TAG_HYPERLINK_TITLE
          : TAG_DISPLAY_CARD_TITLE;
      }),
      hyperlinkButtonLabel: ko.pureComputed(() => {
        return viewModel.isHyperlink()
          ? TO_TAG_DISPLAY_CARD_BUTTON_LABEL
          : TO_TAG_HYPERLINK_BUTTON_LABEL;
      }),
      hyperlinkButtonIcon: ko.pureComputed(() => {
        return viewModel.isHyperlink()
          ? TO_TAG_DISPLAY_CARD_BUTTON_ICON
          : TO_TAG_HYPERLINK_BUTTON_ICON;
      }),
      insertButtonIcon: ko.pureComputed(() => {
        return viewModel.isHyperlink()
          ? INSERT_TAG_HYPERLINK_BUTTON_ICON
          : INSERT_TAG_DISPLAY_CARD_BUTTON_ICON;
      }),
      isHyperLinkModeEnabled: ko.observable(false),
      isHyperlinkValue: ko.observable(false),
      isHyperlink: ko.pureComputed(() => {
        return (
          viewModel.isHyperLinkModeEnabled() &&
          viewModel.isHyperlinkValue() &&
          !(viewModel.isPartOfGroup() && viewModel.isSingle())
        );
      }),
      hyperlinkHasInternalLink: ko.observable(false),
      hyperlinkHasBrandOwnerLink: ko.observable(false),
      hyperlinkVignette: ko.observable(VIGNETTE_ENABLED.NO),
      onClickHyperlinkVignetteYes: () =>
        viewModel.updateHyperlinkVignette(VIGNETTE_ENABLED.YES),
      onClickHyperlinkVignetteNo: () =>
        viewModel.updateHyperlinkVignette(VIGNETTE_ENABLED.NO),
      updateHyperlinkVignette: (update: VIGNETTE_ENABLED) =>
        huit_neuf_this.updateHyperlinkVignette(update),
      hyperlinkInternalLink: ko.observable(HYPERLINK_TYPE.INTERNAL),
      onClickInternalHubPageLink: () =>
        viewModel.updateHyperlinkInternalLink(HYPERLINK_TYPE.INTERNAL),
      onClickBrandOwnerHubPageLink: () =>
        viewModel.updateHyperlinkInternalLink(HYPERLINK_TYPE.BRAND_OWNER),
      updateHyperlinkInternalLink: (update: HYPERLINK_TYPE) =>
        huit_neuf_this.updateHyperlinkInternalLink(update),
      isPartOfGroup: ko.observable(false),
      groupExists: ko.observable(false),
      tag: ko.observable(null),
      idTag: ko.observable(null),
      type: ko.observable(null),
      viewType: ko.observable(null),
      displayType: ko.observable(null),
      showImageGroup: ko.observable(null),
      name: ko.observable(null),
      tagColor: ko.observable(null),
      includeVideo: ko.observable("false"),
      tagVideoThumbnailURL: ko.observable(null),
      tagVideoURL: ko.observable(null),
      tagVideoTitle: ko.observable(null),
      tagVideo: ko.observable(null),
      enableTagVideo: ko.observable(true),
      tagColorOverride: ko.observable(null),
      isTagColorOverrideValue: ko.observable(false),
      isTagColorOverride: ko.pureComputed({
        read: () => {
          return viewModel.isTagColorOverrideValue();
        },
        write: (value) => {
          viewModel.isTagColorOverrideValue(value);
          if (!value) viewModel.tagColorOverride(null);
        },
      }),
      subtitle: ko.observable(null),
      overrideImageToNull: ko.observable(false),
      isTableMode: ko.observable(false),
      badge: ko.observable(null),
      customBadge: ko.observable(null),
      badgeImage: ko.observable(null),
      image: ko.observable(null),
      imageGroup: ko.observable(null),
      vignetteValue: ko.observable(null),
      vignette: ko.pureComputed(this.vignetteComputed.apply(this)),
      imageOverride: ko.observable(null),
      showHyperlinkIcon: ko.observable("true"),
      iconImage: ko.observable(null),
      isIconOverride: ko.observable(false),
      iconOverride: ko.observable(false),
      bannerImage: ko.observable(null),
      description: ko.observable(null),
      descriptionOverride: ko.observable(null),
      seoDescription: ko.observable(null),
      geo: ko.observable(null),
      seoDescriptionOverride: ko.observable(null),
      reviewScore: ko.observable(null),
      reviewScoreOverride: ko.observable(null),
      reviewScoreIsUnderEmbargo: ko.observable(false),
      reviewScoreEmbargoEndDate: ko.observable(null),
      embargoScoreIsIncluded: ko.observable(false),
      specs: ko.observableArray([]),
      allSpecs: ko.observableArray([]),
      affiliateLinks: ko.observableArray([]),
      tempAffiliateLinks: ko.observableArray([]),
      locales: ko.observableArray([]),
      badgeOptions: ko.observableArray([]),
      affiliateUrl: ko.observable(null),
      affiliateAutomaticPricing: ko.observable(null),
      affiliateAutomaticPricingAvailable: ko.observable(false),
      affiliateSalePrice: ko.observable(null),
      tagItemPro: ko.observableArray([]),
      tagItemCon: ko.observableArray([]),
      isVersusStyle: ko.observable(false),
      affiliatePrice: ko.observable(null),
      affiliateExpiration: ko.observable(null),
      affiliateExpirationOption: ko.observable(1),
      affiliateLinkTextOverride: ko.observable(null),
      linkIndex: ko.observable(null),
      permissions: ko.observableArray(
        this.initPermissions(["tag_edit", "tag_type_edit_owned", "tag_color", 'article_edit_embargo'])
      ),
      tagElement: ko.observable(null),
      isSingle: ko.observable(false),
      includeStreamRentBuyLinks: ko.observable(false),
      brandOwner: ko.observable(null),
      presetSelectStep: ko.observable(false),
      ID_TAG_TYPE: ID_TAG_TYPE,
      isBrandOwner: ko.pureComputed(() => {
        const brandOwnerId: number | null =
          huit_neuf_this.getTemplateViewModel().type() &&
          huit_neuf_this.getTemplateViewModel().type().brandOwner
            ? huit_neuf_this.getTemplateViewModel().type().brandOwner.id
            : null;
        const currentBrandId: number | null = huit_neuf_this.parent
          ? huit_neuf_this.parent.getIdBrand()
          : null;

        // loose comparison here
        return brandOwnerId !== null && brandOwnerId == currentBrandId;
      }),
      streamRentBuyLinks: ko.pureComputed(() => {
        // Stream/rent/buy links have something in countryCode attribute and option attribute set to one of stream, rent or buy
        return huit_neuf_this
          .getTemplateViewModel()
          .affiliateLinks()
          .filter(countryCodeFilter)
          .filter(streamRentBuyFilter);
      }),
      hasStreamRentBuyLinks: ko.pureComputed(() => {
        return (
          huit_neuf_this.getTemplateViewModel().streamRentBuyLinks().length > 0
        );
      }),
      defaultStreamRentBuyLinks: ko.pureComputed(() => {
        // Stream/rent/buy links have something in countryCode attribute and option attribute set to one of stream, rent or buy
        const defaults = huit_neuf_this.getTemplateViewModel().tagDefaults();

        return defaults && defaults.affiliateLinks
          ? defaults.affiliateLinks
              .filter(countryCodeFilter)
              .filter(streamRentBuyFilter)
          : [];
      }),
      hasDefaultStreamRentBuyLinks: ko.pureComputed(() => {
        return (
          huit_neuf_this.getTemplateViewModel().defaultStreamRentBuyLinks()
            .length > 0
        );
      }),
      buildAffiliateOptionsString: function () {
        let optionNames = [];
        const streamLinks = TagDefaultsHelper.getAffiliateLinks(huit_neuf_this.getTemplateViewModel());
          for (let sl in streamLinks) {
            if (streamLinks[sl].option && streamLinks[sl].option != "" && optionNames.filter(name => name.name.toLowerCase() === streamLinks[sl].option.toLowerCase()).length == 0) {
              optionNames.push({name: streamLinks[sl].option, count: 1});
            } else if (streamLinks[sl].option && streamLinks[sl].option != "" && optionNames.filter(name => name.name.toLowerCase() === streamLinks[sl].option.toLowerCase()).length >= 0) {
              optionNames.filter(name => name.name.toLowerCase() === streamLinks[sl].option.toLowerCase())[0].count++;
            }
          }

          if (optionNames.length <= 0) {
            return "";
          }

          let optionString = "Include All ";

          for (let on in optionNames) {
            optionString += optionNames[on].name + "/";
          }

          return optionString.slice(0, optionString.length - 1) + " Options";
      },
      tagDefaultColor: ko.observable(""),
      originalTag: ko.observable(null),
      ...TagDefaultsHelper.viewModelProperties,
      imageGroupDisabled: ko.observable(false),
      isTitleOverride: ko.observable(false),
      titleOverride: ko.observable(null),
      referenceDescription: ko.observable(null),
      idReference: ko.observable(null),
      idReferenceAndTagType: ko.observable(null),
      includeCommunityRating: ko.observable(false),
      isGroupCommunityRatingShown: ko.pureComputed(() =>
        huit_neuf_this.parent.getTemplateViewModel().isCommunityRatingShown()
      ),
      communityRating: ko.observable({ average: null, count: 0 }),
      onClickCancel: function (data, event) {
        huit_neuf_this.onClickCancel();
      },
      onClickInsert: function (data, event) {
        huit_neuf_this.onClickInsert();
      },
      onChangeBadge: function (data, event) {
        huit_neuf_this.onChangeBadge(data);
      },
      onClickSave: function (data, event) {
        huit_neuf_this.onClickSave();
      },
      onClickToggleHyperlink: function (data, event) {
        huit_neuf_this.onClickToggleHyperlink();
      },
      onClickAddToGroup: function (data, event) {
        huit_neuf_this.onClickAddToGroup();
      },
      onClickEditImageOverride: function (data, event) {
        huit_neuf_this.onClickEditImageOverride();
      },
      onClickImageOverride: function (data, event) {
        huit_neuf_this.onClickImageOverride();
      },
      onClickIconOverride: function (data, event) {
        huit_neuf_this.onClickIconOverride();
      },
      onClickEditBadgeImage: function (data, event) {
        huit_neuf_this.onClickEditBadgeImage();
      },
      onClickDeleteBadgeImage: function (data, event) {
        huit_neuf_this.onClickDeleteBadgeImage();
      },
      onClickDescriptionOverride: function (data, event) {
        return huit_neuf_this.onClickDescriptionOverride();
      },
      onClickSeoDescriptionOverride: function (data, event) {
        return huit_neuf_this.onClickSeoDescriptionOverride();
      },
      onClickTitleOverride: function (data, event) {
        return huit_neuf_this.onClickTitleOverride();
      },
      onClickReviewScoreOverride: function (data, event) {
        return huit_neuf_this.onClickReviewScoreOverride();
      },
      onClickEditTagSource: function (data, event) {
        huit_neuf_this.onClickEditTagSource();
      },
      onClickDeleteImageOverride: function (data, event) {
        huit_neuf_this.onClickDeleteImageOverride();
      },
      onClickDeleteIconOverride: function (data, event) {
        huit_neuf_this.onClickDeleteIconOverride();
      },
      onClickSelectAllSpecs: function (data, event) {
        huit_neuf_this.onClickSelectAllSpecs();
      },
      onClickDeSelectAllSpecs: function (data, event) {
        huit_neuf_this.onClickDeSelectAllSpecs();
      },
      onClickAddAffiliateLink: function (data, event) {
        huit_neuf_this.onClickAddAffiliateLink();
      },
      onClickCancelAffiliateLink: function (data, event) {
        huit_neuf_this.onClickCancelAffiliateLink();
      },
      onClickShowAffiliateLink: function (data, event) {
        huit_neuf_this.onClickShowAffiliateLink();
      },
      onClickDeleteLink: function (data, event) {
        huit_neuf_this.onClickDeleteLink(data);
      },
      onClickEditLink: function (data, event) {
        huit_neuf_this.onClickEditLink(data);
      },
      onClickAddPro: function (data, event) {
        huit_neuf_this.onClickAddPro();
      },
      onClickDeletePro: function (value, data, event) {
        huit_neuf_this.onClickDeletePro(data, value);
      },
      onClickAddCon: function (data, event) {
        huit_neuf_this.onClickAddCon();
      },
      onClickDeleteCon: function (value, data, event) {
        huit_neuf_this.onClickDeleteCon(data, value);
      },
      onLoadTemplate: function (data, event) {
        huit_neuf_this.onLoadTemplate();
      },
      onClickViewVignette: function (data, event) {
        huit_neuf_this.onClickViewVignette(event, data);
      },
      onClickCloseVignette: function (data, event) {
        huit_neuf_this.onClickCloseVignette(event, data);
      },
      onclickTagNameOverride: function (data, event) {
        huit_neuf_this.onclickTagNameOverride(event, data);
      },
      onClickIncludeCommunityRating: (data, event) =>
        huit_neuf_this.onClickIncludeCommunityRating(event, data),

      handleDragAndDrop: function (
        element,
        currentObservableArray,
        childrenSelector
      ) {
        huit_neuf_this.handleDragAndDrop(
          element,
          currentObservableArray,
          childrenSelector
        );
      },
      onClickPresetLarge: function (data, event) {
        huit_neuf_this.onClickPresetLarge(data);
      },
      onClickPresetMedium: function (data, event) {
        huit_neuf_this.onClickPresetMedium(data);
      },
      onClickPresetSmall: function (data, event) {
        huit_neuf_this.onClickPresetSmall(data);
      },
      onClickPresetReview: function (data, event) {
        huit_neuf_this.onClickPresetReview(data);
      },
      onClickPresetCustom: function (data, event) {
        huit_neuf_this.onClickPresetCustom(data);
      }
    };

    // need this, as the properties of tagDefaults don't seem to be reactive to changes. This determines the color preview background.
    viewModel.tagDefaults.subscribe((newValue, oldValue) => {
      if (oldValue === undefined || newValue.tagColor !== oldValue.tagColor) {
        viewModel.tagDefaultColor(newValue.tagColor);
      }
    });

    viewModel.viewType.subscribe(function (newValue) {
      if (newValue === "hide") {
        viewModel.showImageGroup("false"); // select 'No' when 'Hide Image' is selected
        viewModel.imageGroupDisabled(true);
      } else {
        viewModel.imageGroupDisabled(false);
      }
    });

    const embargoPermissions = ko.pureComputed(() => {
      const permissions = viewModel.permissions()["article_edit_embargo"];
      const { read = false, write = false } = permissions || {};
      return { read, write };
    });

    return {...viewModel, embargoPermissions};
  }

  protected updateHyperlinkInternalLink = (
    hyperlinkType: HYPERLINK_TYPE
  ): boolean => {
    this.getTemplateViewModel().hyperlinkInternalLink(hyperlinkType);
    return true;
  };

  protected updateHyperlinkVignette = (
    vignetteEnabled: VIGNETTE_ENABLED
  ): boolean => {
    this.getTemplateViewModel().hyperlinkVignette(vignetteEnabled);
    return true;
  };

  protected defaultVignetteComputed() {
    const self = this;
    return {
      read: function () {
        return self.getTemplateViewModel().tagDefaults().vignette;
      },
      write: function (vignette) {
        self.getTemplateViewModel().vignetteValue(vignette);
        self.defaultVignettePreview.setVignette(vignette);
        if (!vignette) {
          self.getTemplateViewModel().displayType("image");
        }
      },
    };
  }

  protected vignetteComputed() {
    const self = this;
    return {
      read: function () {
        return self.getTemplateViewModel().vignetteValue();
      },
      write: function (vignette) {
        self.getTemplateViewModel().vignetteValue(vignette);
        self.vignettePreview.setVignette(vignette);
        if (!vignette) {
          self.getTemplateViewModel().displayType("image");
        }
      },
    };
  }

  public onClickViewVignette(event, data) {
    event.target.parentElement.classList.add("is-open");
  }

  public onClickCloseVignette(event, data) {
    event.target.parentElement.classList.remove("is-open");
  }

  public initTagDescriptionOverrideEditor() {
    let tagDisallowedContent = "ul,ol,li";
    //contextmenu,tabletools,tableselection
    let tagRemovePlugins = "elementspath,liststyle,image,forms,list";
    let tagToolbar = [
      [
        "Undo",
        "Redo",
        "-",
        "Link",
        "Unlink",
        "-",
        "SpecialChar",
        "ImgBtn",
        "Bold",
        "Italic",
        "Strike",
        "-",
        "LinkBtn",
      ],
    ];
    let tagEditorHeight = "160px";

    CKEDITOR.replace("tag_description_override", {
      height: tagEditorHeight,
      toolbar: "MA",
      fillEmptyBlocks: false,
      extraAllowedContent: "a[rel];a[target];a[href];a[title];a(*);*[id]",
      disallowedContent: tagDisallowedContent,
      removePlugins: tagRemovePlugins,
      stylesSet: "my_styles",
      format_tags: "p;h1;h2;h3",
      format_p: {
        element: "p",
      },
      toolbar_MA: tagToolbar,
      contentsCss: [
        CKEDITOR.getUrl("contents.css"),
        "/css/cke_style_short.css?v=1.0",
      ],
    });

    //CKEDITOR.config.extraPlugins = "wordcount,notification,openlink";

    tagDescriptionOverrideEditor = CKEDITOR.instances.tag_description_override;
  }

  public setParent(parent): this {
    this.parent = parent;
    return this;
  }

  public setTagElement(tagElement) {
    this.getTemplateViewModel().tagElement(tagElement);
  }

  public setTagImageOverride(image) {
    this.getTemplateViewModel().imageOverride(image);
  }

  public setTagIconOverride(image) {
    this.getTemplateViewModel().iconOverride(image);
    this.getTemplateViewModel().isIconOverride(!!image);
  }

  public setTagImageBadge(image) {
    this.getTemplateViewModel().badgeImage(image);
  }

  public setIsPartOfGroup(isPartOfGroup) {
    this.getTemplateViewModel().isPartOfGroup(isPartOfGroup);
  }

  public setIsSingle(isSingle: boolean) {
    this.getTemplateViewModel().isSingle(isSingle);
  }

  public setGroupExists(groupExists) {
    this.getTemplateViewModel().groupExists(groupExists);
  }

  public setBadgeOptions(badgeOptions) {
    badgeOptions.push({ id: 0, name: "Custom Badge" });

    this.getTemplateViewModel().badgeOptions(badgeOptions);
  }

  public setTag(tag, setOverrides) {
    this.filterAffiliates.clearEverything();
    this.resetValues();

    this.getTemplateViewModel().originalTag(tag);

    //preserve selected specs
    let id = this.getTemplateViewModel().idTag();
    let specs = this.getTemplateViewModel().specs();
    let affiliateLinks = this.getTemplateViewModel().affiliateLinks();
    let tagElement = this.getTemplateViewModel().tagElement();
    let defaultAffiliateLinks = this.getTemplateViewModel().tagDefaults()
      .affiliateLinks
      ? this.getTemplateViewModel().tagDefaults().affiliateLinks
      : [];

    if (id == tag.id) {
      //preserve previous selections after editing source
      for (let spec of tag.specs) {
        if (
          specs.findIndex(
            (s) => s.fieldId == spec.fieldId && s.selected == true
          ) != -1
        ) {
          spec.selected = true;
        }
      }
      //preserve previous selections after editing source
      if (!this.getTemplateViewModel().isBrandOwner()) {
        if (tag.affiliateLinks !== null) {
          for (let link of tag.affiliateLinks) {
            if (
              affiliateLinks.findIndex(
                (l) => l.id == link.id && l.selected == true
              ) != -1
            ) {
              link.selected = true;
            }
          }
        }
      }
    } else {
      if (!setOverrides) {
        this.getTemplateViewModel().badge(null);
        this.getTemplateViewModel().customBadge(null);
        this.getTemplateViewModel().badgeImage(null);
        this.getTemplateViewModel().subtitle(null);
        this.getTemplateViewModel().descriptionOverride(null);
        this.getTemplateViewModel().seoDescriptionOverride(null);
        this.getTemplateViewModel().titleOverride(null);
        this.getTemplateViewModel().reviewScoreOverride(null);
        this.getTemplateViewModel().imageOverride(null);
        this.getTemplateViewModel().tempAffiliateLinks([]);
        tagDescriptionOverrideEditor.setData("", function () {
          this.resetUndo();
        });
      }
    }

    //set whole tag object for editing source
    this.getTemplateViewModel().tag(tag);

    //set viewmodel values
    this.getTemplateViewModel().idTag(tag.id);
    this.getTemplateViewModel().name(tag.name);
    this.getTemplateViewModel().type(tag.type);

    if (this.getTemplateViewModel().isBrandOwner()) {
      if (tag.defaults.affiliateLinks === null) {
        tag.defaults.affiliateLinks = [];
      }
      for (let link of tag.defaults.affiliateLinks) {
        if (
          defaultAffiliateLinks.findIndex(
            (l) => l.id == link.id && l.selected == true
          ) != -1
        ) {
          link.selected = true;
        }
      }
      TagDefaultsHelper.updateTagDefaultValue(
        this.getTemplateViewModel(),
        "affiliateLinks",
        [...tag.defaults.affiliateLinks]
      );
    }

    this.getTemplateViewModel().tagDefaults(tag.defaults);
    this.setupUseTagDefaults(tag);

    this.getTemplateViewModel().brandOwner(
      tag.type && tag.type.brandOwner ? tag.type.brandOwner : null
    );

    if (tag.viewType) {
      this.getTemplateViewModel().viewType(tag.viewType);
    } else {
      // TODO: Default value will be large for listing pages
      this.getTemplateViewModel().viewType("large");
    }

    if (tag.showImageGroup) {
      this.getTemplateViewModel().showImageGroup(tag.showImageGroup);
    } else {
      if (this.getTemplateViewModel().viewType() == "hide") {
        this.getTemplateViewModel().showImageGroup("false");
      } else {
        this.getTemplateViewModel().showImageGroup("true");
      }
    }

    let displayType = tag.displayType,
        vignette = null,
        tagColor = null,
        tagVideo = null,
        reviewScoreEmbargoEndDate,
        reviewScoreIsUnderEmbargo;

    if (tag.details) {
      vignette = tag.details.vignette;
      tagColor = tag.details.color;
      tagVideo = tag.details.video;
      reviewScoreEmbargoEndDate = tag.details.reviewScoreEmbargoEndDate;
      reviewScoreIsUnderEmbargo = tag.details.reviewScoreIsUnderEmbargo;
    }

    this.getTemplateViewModel().includeVideo(
      `${!!tagVideo && !!tag.includeTagVideo}`
    );

    if (!displayType || !vignette) {
      displayType = "image";
    }
    this.getTemplateViewModel().displayType(displayType);

    this.getTemplateViewModel().description(tag.description);
    this.getTemplateViewModel().seoDescription(tag.seoDescription);
    this.getTemplateViewModel().reviewScore(tag.reviewScore);
    this.getTemplateViewModel().reviewScoreIsUnderEmbargo(reviewScoreIsUnderEmbargo);
    this.getTemplateViewModel().reviewScoreEmbargoEndDate(reviewScoreEmbargoEndDate);
    this.getTemplateViewModel().image(tag.image);
    this.getTemplateViewModel().iconImage(tag.iconImage);
    this.getTemplateViewModel().bannerImage(tag.bannerImage);
    this.getTemplateViewModel().imageGroup(tag.imageGroup);
    this.getTemplateViewModel().vignette(vignette);
    this.getTemplateViewModel().tagColor(tagColor);
    this.setTagVideo(tagVideo);
    // if there's a urlHubPage and it's internal; or if you're the brand owner, it's internal by default.
    this.getTemplateViewModel().hyperlinkInternalLink(
      (!!tag.details && !!tag.details.urlHubPage) ||
        this.getTemplateViewModel().isBrandOwner()
        ? HYPERLINK_TYPE.INTERNAL
        : HYPERLINK_TYPE.BRAND_OWNER
    );
    this.getTemplateViewModel().hyperlinkHasInternalLink(
      !!tag.details && !!tag.details.urlHubPage
    );
    this.getTemplateViewModel().hyperlinkHasBrandOwnerLink(
      !!tag.defaults.urlHubPage
    );
    this.getTemplateViewModel().affiliateUrl(null);
    this.getTemplateViewModel().specs([]);
    if (tag.pros) {
      this.getTemplateViewModel().tagItemPro(tag.pros);
      this.getTemplateViewModel().tagItemCon(tag.cons);
    } else {
      this.getTemplateViewModel().tagItemPro([]);
      this.getTemplateViewModel().tagItemCon([]);
    }
    if (typeof tag.specs !== "undefined" && tag.specs !== null) {
      this.getTemplateViewModel().specs(tag.specs);
    }

    this.getTemplateViewModel().allSpecs(tag.allSpecs || []);
    this.getTemplateViewModel().affiliateLinks([]);
    this.getTemplateViewModel().affiliateLinks(tag.affiliateLinks);
    this.getTemplateViewModel().includeCommunityRating(
      tag.includeCommunityRating
    );
    this.getTemplateViewModel().communityRating(tag.communityRating);

    if (setOverrides && tagElement == null) {
      this.setBadge(tag.badge, tag.badgeImage);
      this.getTemplateViewModel().descriptionOverride(tag.descriptionOverride);
      this.getTemplateViewModel().seoDescriptionOverride(
        tag.seoDescriptionOverride
      );
      this.getTemplateViewModel().titleOverride(tag.titleOverride);
      this.getTemplateViewModel().reviewScoreOverride(tag.reviewScoreOverride);
      this.getTemplateViewModel().subtitle(tag.subtitle);
      if (tag.descriptionOverride != null) {
        tagDescriptionOverrideEditor.setData(
          tag.descriptionOverride,
          function () {
            this.resetUndo();
          }
        );
      }
      this.getTemplateViewModel().imageOverride(tag.imageOverride);
      this.getTemplateViewModel().tempAffiliateLinks(tag.tempAffiliateLinks);
    }

    this.getTemplateViewModel().vignette(vignette);
    this.vignettePreview.setIndexedValues(tag, tag.allSpecs);
    this.defaultVignettePreview.setIndexedValues(tag, tag.allSpecs);

    if (tagElement != null) {
      this.loadTagElement(tagElement);
    }

    if (!vignette) {
      this.getTemplateViewModel().displayType("image");
    }

    this.getTemplateViewModel().idReference(tag.idReference);
    this.getTemplateViewModel().referenceDescription(tag.referenceDescription);

    let idReferenceAndTagType = "";
    if (tag.idReference) {
      idReferenceAndTagType = `${tag.idReference} | `;
    }
    if (tag.type) {
      idReferenceAndTagType += `${tag.type.name} ${tag.type.formattedDataset}`;
    } else {
      idReferenceAndTagType += "None";
    }

    this.getTemplateViewModel().idReferenceAndTagType(idReferenceAndTagType);
  }

  public setTableMode() {
    this.getTemplateViewModel().isTableMode(true);
  }

  public getTableMode() {
    return this.getTemplateViewModel().isTableMode();
  }
  protected setBadge(badge, badgeImage) {
    if (badge != null) {
      let badgeOptions = this.getTemplateViewModel().badgeOptions();

      if (badgeOptions.find((b) => b.name == badge) != null) {
        this.getTemplateViewModel().badge(badge);
        this.getTemplateViewModel().customBadge(null);
        this.getTemplateViewModel().badgeImage(null);
      } else {
        this.getTemplateViewModel().badge("Custom Badge");
        this.getTemplateViewModel().customBadge(badge);
        this.getTemplateViewModel().badgeImage(badgeImage);
      }
    } else {
      if (badgeImage != null) {
        this.getTemplateViewModel().badge("Custom Badge");
        this.getTemplateViewModel().customBadge("");
        this.getTemplateViewModel().badgeImage(badgeImage);
      } else {
        this.getTemplateViewModel().badge(null);
        this.getTemplateViewModel().customBadge(null);
        this.getTemplateViewModel().badgeImage(null);
      }
    }
  }

  protected resetValues() {
    this.getTemplateViewModel().descriptionOverride(null);
    tagDescriptionOverrideEditor.setData("", function () {
      this.resetUndo();
    })
    //this.getTemplateViewModel().title(null);
    this.getTemplateViewModel().subtitle(null);
    this.setBadge(null, null);
    this.getTemplateViewModel().tagItemPro([]);
    this.getTemplateViewModel().viewType(null);
    this.getTemplateViewModel().tagItemCon([]);
    this.getTemplateViewModel().imageOverride(null);
    this.getTemplateViewModel().seoDescriptionOverride(null);
    this.getTemplateViewModel().titleOverride(null);
    this.getTemplateViewModel().reviewScoreOverride(null);
    this.getTemplateViewModel().includeStreamRentBuyLinks(false);
    this.getTemplateViewModel().isHyperlinkValue(false);
    this.getTemplateViewModel().hyperlinkVignette(false);
    this.getTemplateViewModel().includeVideo("false");
    this.getTemplateViewModel().showHyperlinkIcon("true");
    this.getTemplateViewModel().isIconOverride(null);
    this.getTemplateViewModel().iconOverride(null);
    this.getTemplateViewModel().isTagColorOverride(null);
    this.getTemplateViewModel().tagColorOverride(null);
  }

  protected loadTagElement(tagElement) {
    this.resetValues();
    if (
      tagElement.classList.contains("tag") ||
      !this.getTemplateViewModel().isHyperLinkModeEnabled()
    ) {
      this.loadDisplayCardTagElement(tagElement);
    } else if (tagElement.classList.contains("hyperlink")) {
      this.loadHyperlinkTagElement(tagElement);
    } else {
      throw new Error(
        "Unknown display card type: " + tagElement.classList.join(" ")
      );
    }
  }

  protected loadHyperlinkTagElement(tagElement) {
    this.getTemplateViewModel().isHyperlinkValue(true);
    let isVignette =
      tagElement.getAttribute(HYPERLINK_DATA_FIELDS.IS_VIGNETTE) === "true";
    let isBrandOwnerUrlHubPage = !!tagElement.getAttribute(
      HYPERLINK_DATA_FIELDS.IS_BRANDOWNER_HUBPAGE
    );
    let isTitleOverride = !!tagElement.getAttribute(
      HYPERLINK_DATA_FIELDS.IS_TITLE_OVERRIDE
    );
    let titleOverride = tagElement.innerText;
    let showHyperlinkIcon =
      tagElement.getAttribute(HYPERLINK_DATA_FIELDS.ICON) === "true";
    let iconOverride = tagElement.getAttribute(
      HYPERLINK_DATA_FIELDS.ICON_OVERRIDE_ID
    );
    let isIconOverride = !!iconOverride;
    let iconOverrideUrl = "";
    let isTagColorOverride = !!tagElement.getAttribute(
      HYPERLINK_DATA_FIELDS.IS_COLOR_OVERRIDE
    );
    let tagColorOverride = isTagColorOverride
      ? tagElement.getAttribute(HYPERLINK_DATA_FIELDS.COLOR)
      : null;

    if (isIconOverride) {
      let style = tagElement.getAttribute("style");
      if (style) {
        let backgroundImage = style.match(/background-image:url\('(.*)'\)/);
        if (backgroundImage) {
          iconOverrideUrl = backgroundImage[1];
        }
      }
    }

    let viewModel = this.getTemplateViewModel();
    viewModel.hyperlinkVignette(
      isVignette ? VIGNETTE_ENABLED.YES : VIGNETTE_ENABLED.NO
    );
    viewModel.hyperlinkInternalLink(
      isBrandOwnerUrlHubPage
        ? HYPERLINK_TYPE.BRAND_OWNER
        : HYPERLINK_TYPE.INTERNAL
    );
    viewModel.titleOverride(isTitleOverride ? titleOverride : null);
    viewModel.showHyperlinkIcon(
      showHyperlinkIcon ? showHyperlinkIcon.toString() : "false"
    );
    viewModel.isIconOverride(isIconOverride);
    viewModel.iconOverride(
      iconOverride ? { id: iconOverride, url: iconOverrideUrl } : null
    );
    viewModel.isTagColorOverride(isTagColorOverride);
    viewModel.tagColorOverride(tagColorOverride);
  }

  protected loadDisplayCardTagElement(tagElement) {
    this.getTemplateViewModel().isHyperlinkValue(false);

    //check if view type exists
    let viewTypeElement = tagElement.querySelector(
      `[data-field="${TAG_DATA_FIELDS.VIEW_TYPE}"]`
    );
    if (viewTypeElement) {
      this.getTemplateViewModel().viewType(viewTypeElement.innerHTML);
    }

    const hasVignette = this.getTemplateViewModel().vignette() != null;

    //check if display type exists
    let displayTypeElement = tagElement.querySelector(
      `[data-field="${TAG_DATA_FIELDS.DISPLAY_TYPE}"]`
    );
    if (displayTypeElement) {
      let displayType = "";
      if (!hasVignette) {
        displayType = "image";
      } else {
        displayType = displayTypeElement.innerHTML;
      }
      this.getTemplateViewModel().displayType(displayType);
    }

    //check if badge exists
    let badgeElement = tagElement.querySelector(
      `[data-field="${TAG_DATA_FIELDS.BADGE}"]`
    );
    let badgeImageElement = tagElement.querySelector(
      `[data-field="${TAG_DATA_FIELDS.BADGE_IMAGE}"]`
    );

    //if badge image but no badge, then the badge was a custom badge
    if (!badgeElement && badgeImageElement) {
      let badgeImage = {
        url: badgeImageElement.src,
        width: badgeImageElement.width,
        height: badgeImageElement.height,
      };
      this.setBadge(null, badgeImage);
    } else if (badgeElement) {
      let badge = badgeElement.innerHTML;
      if (badgeImageElement) {
        let badgeImage = {
          url: badgeImageElement.src,
          width: badgeImageElement.width,
          height: badgeImageElement.height,
        };
        this.setBadge(badge, badgeImage);
      } else {
        this.setBadge(badge, null);
      }
    }

    this.getTemplateViewModel().includeStreamRentBuyLinks(
      tagElement.getAttribute("data-show-streamrentbuy-links") === "true"
    );
    this.getTemplateViewModel().includeCommunityRating(
      tagElement.getAttribute("data-include-community-rating") === "true"
    );

    //check if subtitle exists
    let subTitleElement = tagElement.querySelector(
      `[data-field="${TAG_DATA_FIELDS.SUBTITLE}"]`
    );
    if (subTitleElement) {
      this.getTemplateViewModel().subtitle(subTitleElement.innerHTML);
    }

    let prosAndConsQuery = tagElement.querySelector(
      `[data-field="${TAG_DATA_FIELDS.PROSCONS}"]`
    );
    let prosArray: any[] = [];
    let consArray: any[] = [];
    if (prosAndConsQuery) {
      let prosAndCons = prosAndConsQuery.querySelectorAll("ul");
      let prosList = prosAndCons.item(0);
      if (prosList) {
        for (let pros of prosList.childNodes) {
          prosArray.push({ data: pros.innerText });
        }
      }
      let consList = prosAndCons.item(1);
      if (consList) {
        for (let cons of consList.childNodes) {
          consArray.push({ data: cons.innerText });
        }
      }
    }

    this.getTemplateViewModel().tagItemPro([]);
    this.getTemplateViewModel().tagItemPro(prosArray);

    this.getTemplateViewModel().tagItemCon([]);
    this.getTemplateViewModel().tagItemCon(consArray);
    //check if image is override
    let imageOverrideElement = tagElement.querySelector(
      `[data-field="${TAG_DATA_FIELDS.IMAGE_OVERRIDE}"]`
    );
    let imageItem = tagElement.querySelector(
      `[data-field="${TAG_DATA_FIELDS.IMAGE}"]`
    );
    let vignetteItem = tagElement.querySelector(
      `[data-field="${TAG_DATA_FIELDS.VIGNETTE_ID}"]`
    );

    if (imageOverrideElement) {
      let imageOverride = {
        url: imageOverrideElement.src,
        altText: imageOverrideElement.alt,
        height: imageOverrideElement.height,
        width: imageOverrideElement.width,
      };
      this.getTemplateViewModel().imageOverride(imageOverride);
    } else if (!imageItem && !vignetteItem) {
      this.getTemplateViewModel().viewType("hide");
    }

    //check if description is override
    let descriptionOverrideElement = tagElement.querySelector(
      `[data-field="${TAG_DATA_FIELDS.DESCRIPTION_OVERRIDE}"]`
    );

    if (
        descriptionOverrideElement &&
        descriptionOverrideElement.innerHTML &&
        descriptionOverrideElement.innerHTML.trim() === "<br>"
    ) {
      descriptionOverrideElement.innerHTML = "";
    }
    if (descriptionOverrideElement) {
      this.getTemplateViewModel().descriptionOverride(descriptionOverrideElement.innerHTML == "" ? null : descriptionOverrideElement.innerHTML);
      setTimeout(() => {
        tagDescriptionOverrideEditor.setData(descriptionOverrideElement.innerHTML)
      }, 0)
    }

    let titleOverride = tagElement.querySelector(
      `[data-field="${TAG_DATA_FIELDS.TITLE_OVERRIDE}"]`
    );

    if (
      titleOverride &&
      titleOverride.innerHTML &&
      titleOverride.innerHTML.trim() === "<br>"
    ) {
      titleOverride.innerHTML = ""; // Set to empty string if it's just a <br> tag
    }

    if (titleOverride) {
      //this.getTemplateViewModel().isTitleOverride(true);
      this.getTemplateViewModel().titleOverride(titleOverride.innerHTML);
    }

    //check if seo description is override
    let seoDescriptionOverrideElement = tagElement.querySelector(
      `[data-field="${TAG_DATA_FIELDS.SEO_DESCRIPTION_OVERRIDE}"]`
    );

    if (
      seoDescriptionOverrideElement &&
      seoDescriptionOverrideElement.innerHTML &&
      seoDescriptionOverrideElement.innerHTML.trim() === "<br>"
    ) {
      seoDescriptionOverrideElement.innerHTML = ""; // Set to empty string if it's just a <br> tag
    }

    if (seoDescriptionOverrideElement) {
      this.getTemplateViewModel().seoDescriptionOverride(
        seoDescriptionOverrideElement.innerHTML
      );
    }

    //check if review score is override
    let reviewScoreOverrideElement = tagElement.querySelector(
      `[data-field="${TAG_DATA_FIELDS.REVIEW_SCORE_OVERRIDE}"]`
    );
    if (reviewScoreOverrideElement) {
      this.getTemplateViewModel().reviewScoreOverride(
        isNaN(reviewScoreOverrideElement.innerHTML)
          ? null
          : reviewScoreOverrideElement.innerHTML
      );
    }

    //select the specs
    let specsElement = tagElement.querySelector(
      `[data-field="${TAG_DATA_FIELDS.SPECS}"]`
    );
    let specs = this.getTemplateViewModel().specs();
    if (specsElement) {
      let fieldElements = specsElement.querySelectorAll("dt");
      let selectedSpecs: any[] = [];
      for (let fieldElement of fieldElements) {
        selectedSpecs.push(fieldElement.innerText);
      }

      if (selectedSpecs.length > 0) {
        for (let spec of specs) {
          spec.selected = false;
          if (selectedSpecs.indexOf(spec.label) >= 0) {
            spec.selected = true;
          }
        }
      }
    }

    this.getTemplateViewModel().specs([]);
    this.getTemplateViewModel().specs(specs);

    // check if the image group is hidden
    let imageElement = tagElement.querySelector(".w-img-info");
    let showGroup = imageElement.getAttribute("data-show-img-group")
      ? imageElement.getAttribute("data-show-img-group")
      : "true";
    this.getTemplateViewModel().showImageGroup(showGroup);

    // tag video
    let tagVideoElement = tagElement.querySelector(
      `[data-field="${TAG_DATA_FIELDS.TAG_VIDEO}"]`
    );
    if (tagVideoElement) {
      let tagVideoThumbnailElement = tagElement.querySelector(
        `[data-field="${TAG_DATA_FIELDS.TAG_VIDEO_THUMBNAIL}"]`
      );
      this.getTemplateViewModel().tagVideoTitle(tagVideoElement.innerText);
      this.getTemplateViewModel().tagVideoURL(
        tagVideoElement.getAttribute("url")
      );
      this.getTemplateViewModel().tagVideoThumbnailURL(
        tagVideoThumbnailElement.getAttribute("src")
      );
      this.getTemplateViewModel().includeVideo("true");
    } else {
      this.getTemplateViewModel().includeVideo("false");
    }

    //select the affiliate links
    let affiliateLinksElement = tagElement.querySelector(
      `[data-field="${TAG_DATA_FIELDS.AFFILIATE_LINKS}"]`
    );
    let affiliateLinks = TagDefaultsHelper.getAffiliateLinks(
      this.getTemplateViewModel()
    );
    if(affiliateLinks){
      for (let link of affiliateLinks) {
        link.selected = false;
      }
    }

    let highestId = 0;
    if (affiliateLinksElement) {
      const tagDefaults = this.getTemplateViewModel().useTagDefaults();
      tagDefaults.affiliateLinks = false;
      this.getTemplateViewModel().useTagDefaults(tagDefaults);

      let labelElements = affiliateLinksElement.querySelectorAll("dt");
      let selectedLinks: any[] = [];

      for (let element of labelElements) {
        let value = "";
        let aLink = element.nextSibling.querySelector("a");
        if (aLink) {
          value = aLink.getAttribute("href");
        }
        selectedLinks.push(element.innerText + "_" + value);
      }

      if (selectedLinks.length > 0) {
        for (let link of affiliateLinks) {
          if (link.id > highestId) {
            highestId = link.id;
          }
          link.selected =
            selectedLinks.indexOf(link.type + "_" + link.value) >= 0;
        }
      }
    }

    this.getTemplateViewModel().affiliateLinks([]);
    this.getTemplateViewModel().affiliateLinks(affiliateLinks);

    //get the override affiliate links
    let affiliateLinksOverrideElement = tagElement.querySelector(
      `[data-field="${TAG_DATA_FIELDS.AFFILIATE_LINKS_OVERRIDE}"]`
    );

    let embargoScoreIsIncluded = tagElement.querySelector(
        `[data-field="${TAG_DATA_FIELDS.EMBARGO_SCORE_IS_INCLUDED}"]`
    );

    if (!!embargoScoreIsIncluded) {
      this.getTemplateViewModel().embargoScoreIsIncluded(true);
    }

    if (affiliateLinksOverrideElement) {
      // let affiliateLinks = this.getTemplateViewModel().affiliateLinks();
      let tempAffiliateLinks: any[] = [];
      let labelElements = affiliateLinksOverrideElement.querySelectorAll("dt");
      let valueElements = affiliateLinksOverrideElement.querySelectorAll("dd");
      let allLinks: any[] = [];

      for (let element of labelElements) {
        allLinks.push({
          type: element.innerText,
          selected: true,
          geo: element.getAttribute("data-geo"),
          store: element.getAttribute("data-store"),
        });
      }

      let index = 0;
      for (let element of valueElements) {
        allLinks[index].value = element.childNodes[0].href;
        allLinks[index].price = element.getAttribute("data-price");
        allLinks[index].salePrice = element.getAttribute("data-sale-price");
        allLinks[index].automaticPricing = this.getBooleanAttribute(
          element,
          "data-price-auto"
        );
        allLinks[index].automaticPricingAvailable = this.getBooleanAttribute(
          element,
          "data-auto-available"
        );
        allLinks[index].store = element.getAttribute("data-store");
        allLinks[index].linkTextOverride =
          element.getAttribute("data-text-override");
        allLinks[index].dateExpiration = element.getAttribute(
          "data-expiration-date"
        );
        index += 1;
      }

      //add any temp links that are not part of the tag
      for (let link of allLinks) {
        link.id = highestId + 1;
        highestId += 1;
        link.isNew = true;
        tempAffiliateLinks.push(link);
      }
      this.getTemplateViewModel().tempAffiliateLinks([]);
      this.getTemplateViewModel().tempAffiliateLinks(tempAffiliateLinks);
    } else {
      this.getTemplateViewModel().tempAffiliateLinks([]);
    }
  }

  public setTagVideo(video) {
    this.getTemplateViewModel().tagVideo(video);
    if (video) {
      this.getTemplateViewModel().tagVideoURL(video.url);
      this.getTemplateViewModel().tagVideoThumbnailURL(video.thumbnail.url);
      this.getTemplateViewModel().tagVideoTitle(video.title);
    } else {
      this.getTemplateViewModel().tagVideoURL(null);
      this.getTemplateViewModel().tagVideoThumbnailURL(null);
      this.getTemplateViewModel().tagVideoTitle(null);
    }
  }

  protected onClickCancel() {
    /*let tagElement = this.getTemplateViewModel().tagElement();
        if(tagElement != null){
            this.parent.hide();
        }*/
    this.hide();

    //Reload tag picker template when cancel
    this.caller.getTagData();
  }

  protected onClickEditTagSource() {
    let tag = this.getTemplateViewModel().tag();
    const { tagItemPro, tagItemCon } = this.getTemplateViewModel();
    this.parent.editTagSource({
      ...tag,
      pros: tagItemPro(),
      cons: tagItemCon(),
    });
  }

  public getTag = () => this.getTemplateViewModel().tag();

  public getTagToEdit = () => this.getTemplateViewModel().originalTag();

  protected onClickEditImageOverride() {
    let imageOverride = this.getTemplateViewModel().imageOverride();

    if (imageOverride.id == null) {
      this.caller.getImage(imageOverride.url);
    } else {
      this.caller
        .getImagePickerHelper()
        .editImage(
          "tagImageOverrideEdit",
          "single-select",
          this.imageWidgetForTagOverrideEdit
        );
    }

    //this.caller.showImagePicker("single-select", "tagImageOverrideEdit", [], this.imageWidgetForTagOverrideEdit);
    //5this.parent.getImage
    //this.caller.articlesEdit.imagePicker.showEdit();
  }

  protected onClickImageOverride() {
    this.caller
      .getImagePickerHelper()
      .showImagePicker(
        "single-select",
        "tagImageOverride",
        [],
        this.imageWidgetForTagOverrideEdit
      );
  }

  protected onClickIconOverride() {
    this.caller
      .getImagePickerHelper()
      .showImagePicker(
        "single-select",
        "tagIconOverride",
        [],
        this.imageWidgetForTagIconOverrideEdit
      );
  }

  protected onClickDeleteImageOverride() {
    this.getTemplateViewModel().imageOverride(null);
  }

  protected onClickDeleteIconOverride() {
    this.setTagIconOverride(null);
  }

  protected onClickEditBadgeImage() {
    this.caller
      .getImagePickerHelper()
      .showImagePicker("single-select", "tagImageBadge");
  }

  protected onClickDeleteBadgeImage() {
    this.getTemplateViewModel().badgeImage(null);
  }

  protected onLoadTemplate() {
    //this.linkExpirationDatePicker.buildCalendar(this.createEasternTimeZoneDateTime());
  }

  protected onClickSelectAllSpecs() {
    let specs = this.getTemplateViewModel().specs();
    for (let spec of specs) {
      spec.selected = true;
    }
    this.getTemplateViewModel().specs([]);
    this.getTemplateViewModel().specs(specs);
  }

  protected onClickAddPro() {
    this.getTemplateViewModel().tagItemPro.push({ data: "" });
  }

  protected onClickAddCon() {
    this.getTemplateViewModel().tagItemCon.push({ data: "" });
  }

  protected onClickDeleteCon(data, index) {
    this.getTemplateViewModel().tagItemCon.splice(index(), 1);
  }

  protected onClickDeletePro(data, index) {
    this.getTemplateViewModel().tagItemPro.splice(index(), 1);
  }

  protected onClickDeSelectAllSpecs() {
    let specs = this.getTemplateViewModel().specs();
    for (let spec of specs) {
      spec.selected = false;
    }
    this.getTemplateViewModel().specs([]);
    this.getTemplateViewModel().specs(specs);
  }

  protected onClickDescriptionOverride() {

    const viewModel = this.getTemplateViewModel();
    const currentValue = viewModel.descriptionOverride();

    viewModel.descriptionOverride(currentValue != null ? null : "");
    tagDescriptionOverrideEditor.setData(currentValue != null ? null : "");
    return true;
  }

  protected onClickSeoDescriptionOverride(): boolean {
    const viewModel = this.getTemplateViewModel();
    const currentValue = viewModel.seoDescriptionOverride();

    viewModel.seoDescriptionOverride(currentValue != null ? null : "");
    return true;
  }

  protected onClickTitleOverride() {
    let titleOverride = this.getTemplateViewModel().titleOverride();
    if (titleOverride != null) {
      this.getTemplateViewModel().titleOverride(null);
    } else {
      this.getTemplateViewModel().titleOverride("");
    }
    return true;
  }

  protected onClickReviewScoreOverride() {
    let reviewScoreOverride = this.getTemplateViewModel().reviewScoreOverride();
    if (reviewScoreOverride != null) {
      this.getTemplateViewModel().reviewScoreOverride(null);
    } else {
      this.getTemplateViewModel().reviewScoreOverride("");
    }
    return true;
  }

  protected onChangeBadge(data) {
    let badgeSelected = data.badge();

    this.getTemplateViewModel().customBadge(null);
    this.getTemplateViewModel().badgeImage(null);
  }

  protected onClickInsert() {
    let elementToReplace = this.getTemplateViewModel().tagElement();

    if (this.getTemplateViewModel().isHyperlink() == true) {
      let tagHyperlinkObject = this.getTagHyperlinkObject();
      this.parent.insertTagHyperlink(
        elementToReplace,
        tagHyperlinkObject,
        false
      );
    } else {
      let tagObject = this.getTagObject();
      this.parent.insertTag(elementToReplace, tagObject);
    }
    this.getTemplateViewModel().tagElement(null);
  }

  protected onClickSave() {
    let tagObject = this.getTagObject();
    this.parent.updateSelectedTag(tagObject);
    this.hide();
  }

  protected onClickToggleHyperlink() {
    const vm = this.getTemplateViewModel();

    if (vm.isHyperLinkModeEnabled()) {
      vm.isHyperlinkValue(!vm.isHyperlinkValue());
      if (vm.isHyperlinkValue()) {
        if (!vm.hyperlinkInternalLink()) {
          vm.hyperlinkInternalLink(HYPERLINK_TYPE.INTERNAL);
        }
        if (!vm.hyperlinkVignette()) {
          vm.hyperlinkVignette(VIGNETTE_ENABLED.YES);
        }
      }
    }
  }

  protected onClickAddToGroup() {
    this.parent.onClickTag(this.getTagObject());
  }

  public getOverrideImageToNull() {
    return this.getTemplateViewModel().viewType() == "hide" ? true : false;
  }

  protected getTagObject() {
    const includeStreamRentBuyLinks: boolean =
      this.getTemplateViewModel().includeStreamRentBuyLinks();
    const hasStreamRentBuyLinks: boolean = this.getTemplateViewModel().hasStreamRentBuyLinks();
    let id = this.getTemplateViewModel().idTag();
    let name = this.getTemplateViewModel().name();
    let subtitle = this.getTemplateViewModel().subtitle();
    let badge = this.getTemplateViewModel().badge();
    let customBadge = this.getTemplateViewModel().customBadge();
    let badgeImage = this.getTemplateViewModel().badgeImage();
    let type = this.getTemplateViewModel().type();
    let viewType = this.getTemplateViewModel().viewType();
    let displayType = this.getTemplateViewModel().displayType();
    let description = this.getTemplateViewModel().description();
    let seoDescription = this.getTemplateViewModel().seoDescription();
    let seoDescriptionOverride =
      this.getTemplateViewModel().seoDescriptionOverride();
    let reviewScore = this.getTemplateViewModel().reviewScore();
    let reviewScoreOverride = this.getTemplateViewModel().reviewScoreOverride();
    let includeCommunityRating =
      this.getTemplateViewModel().includeCommunityRating();
    let communityRating = this.getTemplateViewModel().communityRating();
    let image = this.getTemplateViewModel().image();
    let imageGroup = this.getTemplateViewModel().imageGroup();
    let imageOverride = this.getTemplateViewModel().imageOverride();
    let iconImage = this.getTemplateViewModel().iconImage();
    let bannerImage = this.getTemplateViewModel().bannerImage();
    let showImageGroup = this.getTemplateViewModel().showImageGroup();
    let vignette = this.getTemplateViewModel().vignette();
    let color = this.getTemplateViewModel().tagColor();
    let specs = this.getTemplateViewModel().specs();
    let selectedSpecs = specs.filter((s) => s.selected == true);
    let allSpecs = this.getTemplateViewModel().allSpecs();
    let affiliateLinks = TagDefaultsHelper.getAffiliateLinks(
      this.getTemplateViewModel()
    );
    let tempAffiliateLinks = this.getTemplateViewModel().tempAffiliateLinks();
    let selectedAffiliateLinks = null;

    if (Array.isArray(affiliateLinks) && affiliateLinks.length > 0) {
      if(hasStreamRentBuyLinks) {
        selectedAffiliateLinks = affiliateLinks.filter((l: AffiliateLink) => {
          return l.selected === true && !l.option;
        })
      } else {
        selectedAffiliateLinks = affiliateLinks.filter((l: AffiliateLink) => {
          return l.selected === true;
        })
      }
    } else {
      selectedAffiliateLinks = [];
    }

    let descriptionOverride = this.getTemplateViewModel().descriptionOverride();
    let pros = this.getTemplateViewModel().tagItemPro();
    let cons = this.getTemplateViewModel().tagItemCon();
    let overrideImageToNull = this.getTemplateViewModel().overrideImageToNull();
    let titleOverride = this.getTemplateViewModel().titleOverride();
    let isTitleOverride = this.getTemplateViewModel().isTitleOverride();
    let includeTagVideo = this.getTemplateViewModel().includeVideo() === "true";
    let tagVideo = includeTagVideo
      ? this.getTemplateViewModel().tagVideo()
      : null;
    let tagDefaults = this.getTemplateViewModel().tagDefaults();

    if (displayType == "vignette") {
      iconImage = null;
    }

    if (
      descriptionOverride != null &&
      tagDescriptionOverrideEditor.getData() != ""
    ) {
      descriptionOverride = tagDescriptionOverrideEditor.getData();
    }

    if (customBadge != null) {
      badge = customBadge;
    }
    if (isTitleOverride && titleOverride == null) {
      titleOverride = "";
    }

    const reviewScoreIsUnderEmbargo = this.getTemplateViewModel().reviewScoreIsUnderEmbargo();
    const reviewScoreEmbargoEndDate = this.getTemplateViewModel().reviewScoreEmbargoEndDate();
    const embargoScoreIsIncluded = this.getTemplateViewModel().embargoScoreIsIncluded();

    return {
      id: id,
      name: name,
      badge: badge,
      badgeImage: badgeImage,
      subtitle: subtitle,
      type: type,
      viewType: viewType,
      displayType: displayType,
      description: description,
      descriptionOverride: descriptionOverride,
      seoDescription: seoDescription,
      overrideImageToNull: overrideImageToNull,
      seoDescriptionOverride: seoDescriptionOverride,
      reviewScore: reviewScore,
      pros: pros,
      cons: cons,
      reviewScoreOverride: reviewScoreOverride,
      embargoScoreIsIncluded : embargoScoreIsIncluded,
      image: image,
      imageGroup: imageGroup,
      imageOverride: imageOverride,
      iconImage: iconImage,
      bannerImage: bannerImage,
      showImageGroup: showImageGroup,
      details: {
        vignette: vignette,
        color: color,
        video: tagVideo,
        reviewScoreIsUnderEmbargo: reviewScoreIsUnderEmbargo,
        reviewScoreEmbargoEndDate: reviewScoreEmbargoEndDate
      },
      defaults: {
        vignette: tagDefaults.vignette,
        color: tagDefaults.tagColor,
      },
      specs: specs,
      selectedSpecs: selectedSpecs,
      allSpecs: allSpecs,
      affiliateLinks: affiliateLinks,
      tempAffiliateLinks: tempAffiliateLinks,
      includeStreamRentBuyLinks: includeStreamRentBuyLinks,
      selectedAffiliateLinks: selectedAffiliateLinks.filter(
        (l) => l.selected == true
      ),
      titleOverride: titleOverride,
      includeCommunityRating: includeCommunityRating,
      communityRating: communityRating,
    };
  }

  protected getTagHyperlinkObject(): TagHyperlink {
    let tag = this.getTemplateViewModel().tag();

    let titleOverride = this.getTemplateViewModel().titleOverride();
    let isTitleOverride =
      typeof titleOverride !== "undefined" && titleOverride !== null;

    let isTagColorOverride = this.getTemplateViewModel().isTagColorOverride();
    let tagColorOverride = this.getTemplateViewModel().tagColorOverride();

    let hyperlinkVignette =
      this.getTemplateViewModel().hyperlinkVignette() === VIGNETTE_ENABLED.YES;
    let isBrandOwnerUrlHubPage =
      this.getTemplateViewModel().hyperlinkInternalLink() ===
      HYPERLINK_TYPE.BRAND_OWNER;

    let showHyperlinkIcon =
      this.getTemplateViewModel().showHyperlinkIcon() === "true";

    let tagHyperlink: TagHyperlink = {
      tag: tag,
      isVignette: hyperlinkVignette,
      isBrandOwnerUrlHubPage: isBrandOwnerUrlHubPage,
      showHyperlinkIcon: showHyperlinkIcon,
    };

    if (isTitleOverride) {
      tagHyperlink.isTitleOverride = true;
      tagHyperlink.titleOverride = titleOverride;
    }

    if (isTagColorOverride) {
      tagHyperlink.isTagColorOverride = true;
      tagHyperlink.colorOverride = tagColorOverride;
    }

    if (showHyperlinkIcon) {
      let isIconOverride = this.getTemplateViewModel().isIconOverride();
      tagHyperlink.isIconOverride = isIconOverride;
      if (isIconOverride) {
        let iconOverride = this.getTemplateViewModel().iconOverride();
        tagHyperlink.iconOverride = iconOverride;
      }
    }

    return tagHyperlink;
  }

  private saveImage(insert, param) {
    //this.parent.saveImages([this.getImage()], insert, param);
  }

  public show() {
    this.getTemplateViewModel().isShown(true);
  }

  public hide() {
    this.getTemplateViewModel().isShown(false);
  }

  public setPermissions(permissions) {
    this.getTemplateViewModel().permissions(permissions);
  }

  public showLoading() {
    let form = document.getElementById("tag-picker-view");
    form!.classList.add("loading");
  }

  public hideLoading() {
    let form = document.getElementById("tag-picker-view");
    form!.classList.remove("loading");
  }

  protected onClickDeleteLink(data) {
    let tempAffiliateLinks = this.getTemplateViewModel().tempAffiliateLinks();
    tempAffiliateLinks = tempAffiliateLinks.filter((l) => l.id != data.id);
    this.getTemplateViewModel().tempAffiliateLinks([]);
    this.getTemplateViewModel().tempAffiliateLinks(tempAffiliateLinks);
  }

  protected onClickPreviewLink(data) {
    let url = data.value;

    let element = document.createElement("a");
    element.setAttribute("href", url);
    element.setAttribute("target", "_blank");
    element.style.display = "none";
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }

  protected onClickEditLink(link) {
    let validAutoPricingPartnerNames =
      this.parent.getValidAutoPricingPartnerNames();
    let affiliateLinks = this.getTemplateViewModel().tempAffiliateLinks();
    let linkIndex = affiliateLinks.findIndex((l) => l == link);
    this.getTemplateViewModel().linkIndex(linkIndex);

    // get what is already manually or automatically set on the link
    let isAutomatic =
      link.automaticPricing == true ||
      link.automaticPricing == "true" ||
      link.automaticPricing == 1;
    let isLinkAutomaticAvailable =
      link.affiliateAutomaticPricingAvailable == true ||
      link.affiliateAutomaticPricingAvailable == "true" ||
      link.affiliateAutomaticPricingAvailable == 1;

    // whether automatic pricing is available at all from the db
    let isAutomaticAvailable =
      typeof link.type !== "undefined" &&
      validAutoPricingPartnerNames.includes(link.type);

    this.resetAffiliateForm();
    this.getTemplateViewModel().affiliatePrice(link.price);
    this.getTemplateViewModel().affiliateSalePrice(link.salePrice);
    this.getTemplateViewModel().affiliateAutomaticPricing(
      link.automaticPricing
    );
    this.getTemplateViewModel().affiliateAutomaticPricingAvailable(
      isAutomaticAvailable
    );
    this.getTemplateViewModel().affiliateLinkTextOverride(
      link.linkTextOverride
    );
    this.getTemplateViewModel().affiliateExpirationOption(1);
    this.getTemplateViewModel().affiliateUrl(link.value);

    this.filterAffiliates.setOption({
      name: link.type,
      id: link.id,
      geo: link.geo,
      store: link.store,
      showAutoPricing: isAutomatic,
      hasPricingSources: isLinkAutomaticAvailable,
    });

    if (link.dateExpiration != null) {
      //check if expiry date has passed
      let currentDate = this.createEasternTimeZoneDateTime();
      let dateExpiration = new Date(link.dateExpiration);

      if (dateExpiration > currentDate) {
        //scheduled
        this.getTemplateViewModel().affiliateExpirationOption(3);
        this.linkExpirationDatePicker.setDate(
          link.dateExpiration.replaceAll("-", "/")
        );
      } else {
        //expired
        this.getTemplateViewModel().affiliateExpirationOption(2);
      }
    }

    this.getTemplateViewModel().isAffiliateLinksFormShown(true);
  }

  protected onClickShowAffiliateLink() {
    this.resetAffiliateForm();
    this.getTemplateViewModel().linkIndex(null);
    this.filterAffiliates.setPlaceholder("Affiliate Partner");
    this.filterAffiliates.clearEverything();
    this.getTemplateViewModel().isAffiliateLinksFormShown(true);
  }

  protected resetAffiliateForm() {
    this.getTemplateViewModel().affiliatePrice(null);
    this.getTemplateViewModel().affiliateAutomaticPricingAvailable(false);
    this.getTemplateViewModel().affiliateAutomaticPricing(null);
    this.getTemplateViewModel().affiliateSalePrice(null);
    this.getTemplateViewModel().affiliateUrl(null);
    this.getTemplateViewModel().affiliateLinkTextOverride(null);
    this.getTemplateViewModel().affiliateExpirationOption(1);
    this.filterAffiliates.clearEverything();
  }

  protected onClickCancelAffiliateLink() {
    this.getTemplateViewModel().isAffiliateLinksFormShown(false);
  }

  protected onClickAddAffiliateLink() {
    let defaultPlaceholder = "Affiliate Partner";
    let noPartnerSelected = "No Partner Selected";
    let alreadyAdded = "Affiliate Partner Already Added With The Same Url";
    let affiliateUrl = this.getTemplateViewModel().affiliateUrl();
    let affiliateAutomaticPricing =
      this.getTemplateViewModel().affiliateAutomaticPricing();
    let affiliateAutomaticPricingAvailable =
      this.getTemplateViewModel().affiliateAutomaticPricingAvailable();
    let affiliateSalePrice =
      this.getTemplateViewModel().affiliateSalePrice() &&
      !affiliateAutomaticPricing
        ? Math.round(this.getTemplateViewModel().affiliateSalePrice() * 100) /
          100
        : null;
    let affiliatePrice =
      this.getTemplateViewModel().affiliatePrice() && !affiliateAutomaticPricing
        ? Math.round(this.getTemplateViewModel().affiliatePrice() * 100) / 100
        : null;
    let affiliateLinkTextOverride =
      this.getTemplateViewModel().affiliateLinkTextOverride();
    let affiliateExpirationOption =
      this.getTemplateViewModel().affiliateExpirationOption();
    let affiliateExpirationDate =
      this.getTemplateViewModel().linkExpirationDatePicker.singleDatePicker();
    let linkIndex = this.getTemplateViewModel().linkIndex();
    if (this.filterAffiliates.getOptionObj() != null) {
      this.getTemplateViewModel().geo(this.filterAffiliates.getOptionObj().geo);
    } else {
      this.getTemplateViewModel().geo(null);
    }
    let dateExpiration = null;

    if (affiliateExpirationOption == 2) {
      //now
      dateExpiration = this.getFormattedEasternTimeZoneDateTime("-");
    } else if (affiliateExpirationOption == 3) {
      //scheduled
      dateExpiration = affiliateExpirationDate.replaceAll("/", "-");
    }

    let affiliateLinks = TagDefaultsHelper.getAffiliateLinks(
      this.getTemplateViewModel()
    );
    let tempAffiliateLinks = this.getTemplateViewModel().tempAffiliateLinks();
    let highestId = 1;
    if (Array.isArray(affiliateLinks) && affiliateLinks.length > 0) {
      for (let a of affiliateLinks) {
        if (a.id > highestId) {
          highestId = a.id;
        }
      }
    }
    if (Array.isArray(tempAffiliateLinks) && tempAffiliateLinks.length > 0) {
      for (let a of tempAffiliateLinks) {
        if (a.id > highestId) {
          highestId = a.id;
        }
      }
    } else {
      tempAffiliateLinks = [];
    }
    if (this.filterAffiliates.getTemplateViewModel().addNewSelected()) {
      let optionName = this.filterAffiliates
        .getTemplateViewModel()
        .newOptionName();

      if (optionName != "") {
        this.filterAffiliates.setPlaceholder(defaultPlaceholder);
        if (affiliateUrl != null && affiliateUrl != "") {
          let newLink = {
            id: highestId + 1,
            automaticPricing: affiliateAutomaticPricing,
            automaticPricingAvailable: affiliateAutomaticPricingAvailable,
            salePrice: affiliateSalePrice,
            price: affiliatePrice,
            linkTextOverride: affiliateLinkTextOverride,
            type: optionName,
            value: affiliateUrl,
            expirationOption: affiliateExpirationOption,
            dateExpiration: dateExpiration,
            selected: true,
            isNew: true,
          };

          if (linkIndex != null) {
            //preserve selection
            newLink.selected = tempAffiliateLinks[linkIndex].selected;
            tempAffiliateLinks[linkIndex] = newLink;
          } else {
            tempAffiliateLinks.push(newLink);
          }

          this.filterAffiliates.clearEverything();
          this.getTemplateViewModel().affiliateUrl(null);
          this.getTemplateViewModel().isAffiliateLinksFormShown(false);
        }
      } else {
        this.filterAffiliates.setPlaceholder(noPartnerSelected);
      }
    } else if (this.filterAffiliates.getTemplateViewModel().optionObj()) {
      let affiliate = this.filterAffiliates.getTemplateViewModel().optionObj();
      this.filterAffiliates.setPlaceholder(defaultPlaceholder);
      if (affiliateUrl != null && affiliateUrl != "") {
        let tempAffiliateInList: any[] = [];
        if (
          Array.isArray(tempAffiliateLinks) &&
          tempAffiliateLinks.length > 0
        ) {
          for (let i = 0; i < tempAffiliateLinks.length; i++) {
            let tal = tempAffiliateLinks[i];
            if (
              tal.store == affiliate.store &&
              tal.value == affiliateUrl &&
              i != linkIndex
            ) {
              tempAffiliateInList.push(tal);
            }
          }
        }
        if (tempAffiliateInList.length == 0) {
          let newLink = {
            id: affiliate.id,
            automaticPricing: affiliateAutomaticPricing,
            automaticPricingAvailable: affiliateAutomaticPricingAvailable,
            salePrice: affiliateSalePrice,
            price: affiliatePrice,
            geo: affiliate.geo,
            store: affiliate.store,
            linkTextOverride: affiliateLinkTextOverride,
            type: affiliate.name,
            value: affiliateUrl,
            expirationOption: affiliateExpirationOption,
            dateExpiration: dateExpiration,
            selected: true,
            isNew: true,
          };

          if (linkIndex != null) {
            //preserve selection
            newLink.selected = tempAffiliateLinks[linkIndex].selected;
            tempAffiliateLinks[linkIndex] = newLink;
          } else {
            tempAffiliateLinks.push(newLink);
          }

          this.filterAffiliates.clearEverything();
          this.getTemplateViewModel().affiliateUrl(null);
          this.getTemplateViewModel().isAffiliateLinksFormShown(false);
        } else {
          this.filterAffiliates.setPlaceholder(alreadyAdded);
        }
      }
    } else {
      this.filterAffiliates.setPlaceholder(noPartnerSelected);
    }

    this.getTemplateViewModel().tempAffiliateLinks([]);
    this.getTemplateViewModel().tempAffiliateLinks(tempAffiliateLinks);
  }

  private getFormattedEasternTimeZoneDateTime(delimiter): any {
    let date = this.createEasternTimeZoneDateTime();

    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hour = date.getHours();
    let minutes = date.getMinutes();

    return (
      year +
      delimiter +
      this.padInteger(month, 2) +
      delimiter +
      this.padInteger(day, 2) +
      " " +
      this.padInteger(hour, 2) +
      ":" +
      this.padInteger(minutes, 2)
    );
  }

  private padInteger(number: number, size: number) {
    let s = number + "";
    while (s.length < size) s = "0" + s;
    return s;
  }

  private createEasternTimeZoneDateTime(date?: Date): Date {
    if (!date) {
      date = new Date();
    }

    date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
    //checks if DST is currently being observed, adjusts offset accordingly
    let easternTimeOffset = this.isDstObserved(date) ? -240 : -300;
    date.setMinutes(date.getMinutes() + easternTimeOffset);

    return date;
  }

  public isDstObserved(date: Date) {
    let jan = new Date(date.getFullYear(), 0, 1);
    let jul = new Date(date.getFullYear(), 6, 1);
    let stdTimezoneOffset = Math.max(
      jan.getTimezoneOffset(),
      jul.getTimezoneOffset()
    );

    return date.getTimezoneOffset() < stdTimezoneOffset;
  }

  public handleDragAndDrop(
    element,
    currentObservableArray,
    childrenSelector
  ): any {
    DragAndDropHandler.handleDragAndDrop(
      element,
      currentObservableArray,
      childrenSelector
    );
  }

  public getBooleanAttribute(element, attributeName) {
    let attributeValue = element.getAttribute(attributeName);
    return (
      attributeValue === "true" ||
      attributeValue === true ||
      attributeValue === "1"
    );
  }

  public onClickIncludeCommunityRating(event, data) {
    this.getTemplateViewModel().includeCommunityRating(
      !this.getTemplateViewModel().includeCommunityRating()
    );
    return true;
  }

  public onclickTagNameOverride(event, data) {
    let tagNameOverride = this.getTemplateViewModel().isTitleOverride();

    if (tagNameOverride != null) {
      this.getTemplateViewModel().tagNameOverride(null);
    } else {
      this.getTemplateViewModel().tagNameOverride("");
    }

    //tagDescriptionOverrideEditor.setData("");
    return true;
  }

  public setPresetSelectStep(presetSelectStep) {
    this.getTemplateViewModel().presetSelectStep(presetSelectStep);
  }

  public onClickPresetLarge(data) {
    this.getTemplateViewModel().viewType("large");

    // don't include description
    this.getTemplateViewModel().descriptionOverride("");
    // don't include community rating
    this.getTemplateViewModel().includeCommunityRating(false);

    // include streamrentbuylinks
    if(this.getTemplateViewModel().hasStreamRentBuyLinks()) {
      this.getTemplateViewModel().includeStreamRentBuyLinks(true);
    }

    this.selectAllAffiliateLinks();
    // load specs
    this.setTagPresetSpecs(tagPickerPresets.PRESET_LARGE);
    this.getTemplateViewModel().presetSelectStep(false);

    this.onClickInsert();
  }

  public onClickPresetMedium(data) {
    this.getTemplateViewModel().viewType("medium");

    // don't include description
    this.getTemplateViewModel().descriptionOverride("");
    // don't include community rating
    this.getTemplateViewModel().includeCommunityRating(false);

    // include streamrentbuylinks
    if(this.getTemplateViewModel().hasStreamRentBuyLinks()) {
      this.getTemplateViewModel().includeStreamRentBuyLinks(true);
    }

    this.selectAllAffiliateLinks();
    // load specs
    this.setTagPresetSpecs(tagPickerPresets.PRESET_MEDIUM);
    this.getTemplateViewModel().presetSelectStep(false);

    this.onClickInsert();
  }

  public onClickPresetSmall(data) {
    this.getTemplateViewModel().viewType("small");

    // don't include description
    this.getTemplateViewModel().descriptionOverride("");
    // don't include community rating
    this.getTemplateViewModel().includeCommunityRating(false);

    // include streamrentbuylinks
    if(this.getTemplateViewModel().hasStreamRentBuyLinks()) {
      this.getTemplateViewModel().includeStreamRentBuyLinks(true);
    }

    this.selectAllAffiliateLinks();
    // load specs
    this.setTagPresetSpecs(tagPickerPresets.PRESET_SMALL);
    this.getTemplateViewModel().presetSelectStep(false);

    this.onClickInsert();
  }

  public onClickPresetReview(data) {
    this.getTemplateViewModel().viewType("large");

    // don't include description
    this.getTemplateViewModel().descriptionOverride("");
    // don't include community rating
    this.getTemplateViewModel().includeCommunityRating(false);

    // include streamrentbuylinks
    if(this.getTemplateViewModel().hasStreamRentBuyLinks()) {
      this.getTemplateViewModel().includeStreamRentBuyLinks(true);
    }

    this.selectAllAffiliateLinks();
    // load specs
    this.setTagPresetSpecs(tagPickerPresets.PRESET_LARGE);
    this.getTemplateViewModel().presetSelectStep(false);

  }

  public onClickPresetCustom(data) {
    this.getTemplateViewModel().presetSelectStep(false);
  }

  public setTagPresetSpecs(preset) {

    const specsConfig = tagPickerPresets.TAG_PICKER_PRESET_DEFAULT_FIELDS[preset];

    if (!specsConfig) {
      return;
    }

    const tagType = this.getTemplateViewModel().type();
    const tagTypeId = tagType ? tagType.id : null;
    const tagTypeSpecs = specsConfig[tagTypeId] || null;

    // if no tag type matching preset, activate the fallback number of specs
    if (!tagTypeId || !tagTypeSpecs) {
      const fallback = tagPickerPresets.TAG_PICKER_PRESET_DEFAULT_FIELDS_FALLBACK[preset];

      if (!fallback) {
        return;
      }

      const specs = this.getTemplateViewModel().specs();

      specs.forEach((spec, index) => {
        if (index < fallback) {
          spec.selected = true;
        }
      });
      this.getTemplateViewModel().specs([]);
      this.getTemplateViewModel().specs(specs);

    } else {
      const specs = this.getTemplateViewModel().specs();
      const activeSpecs = [];

      // activate specs found in the preset
      tagTypeSpecs.forEach(specId => {
        let foundSpec = specs.find(spec => spec.fieldId == specId);

        if (foundSpec) {
          foundSpec.selected = true;
          activeSpecs.push(foundSpec);
        }
      });

      // de-activate specs not found in the preset
      const inactiveSpecs = specs.filter(spec => !tagTypeSpecs.includes(spec.fieldId));
      inactiveSpecs.forEach(spec => {
        spec.selected = false;
      })

      const allSpecs = activeSpecs.concat(inactiveSpecs);

      this.getTemplateViewModel().specs([]);
      this.getTemplateViewModel().specs(allSpecs);
    }
  }

  public selectAllAffiliateLinks() {

    const tagDefaults = this.getTemplateViewModel().useTagDefaults();
    tagDefaults.affiliateLinks = false;

    this.getTemplateViewModel().useTagDefaults(tagDefaults);

    const links = this.getTemplateViewModel().affiliateLinks();
    links.forEach(link => {
      link.selected = true;
    });
    this.getTemplateViewModel().affiliateLinks([]);
    this.getTemplateViewModel().affiliateLinks(links);
  }

}



// WEBPACK FOOTER //
// ./js/components/templates/tagPickerView_template.ts